import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useLocation, useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../config';

import RenovationIcon from '../images/home-landing-page/renovation-icon.png';
import Checkmark from '../images/home-landing-page/blue-checkmark.png';

import Slider from "react-slick";
import Footer from '../components/Footer/footer';
import DashboardNavbar from '../components/Navbar/navbar-dashboard';
import { jwtDecode } from 'jwt-decode';
import EmptyProfileImage from '../images/navbar/empty-profile-image.png'
import StarRating from '../components/StarRating/startRating';
import Loader from '../components/Loader';
import showToast from '../components/ShowToast';
import RecentDate from '../components/RecentDate';
import EmptyBuildStartImage from '../images/home-landing-page/Empty-img.png';

const BusinessProfile = () =>
{
  const [businessProfile, setBusinessProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [certs, setCerts] = useState(null);
  const [services, setServices] = useState(null);
  const [jobCompleted, setJobCompleted] = useState(0);
  const [jobsQuote, setJobQuote] = useState(0);
  const [conversationsCount, setConversationsCount] = useState(0);
  const [reviewOfCustomer, setReviewOfCustomer] = useState(null);
  const [expandedItems, setExpandedItems] = useState({});
  const [viewReviewForBusiness, setViewReviewForBusiness] = useState(null);
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const businessIdFromQuery = queryParams.get('businessId');

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [loggedUserProfilePic, setLoggedUserProfilePic] = useState(null);
  const [loggedUserName, setLoggedUserName] = useState(null);

  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [isViewReviewPopup, setIsViewReviewPopup] = useState(false);
  const [ratingQuality, setRatingQuality] = useState(0);
  const [ratingService, setRatingService] = useState(0);
  const [ratingCommunication, setRatingCommunication] = useState(0);
  const [ratingPromptness, setRatingPromptness] = useState(0);
  const [ratingCompletion, setRatingCompletion] = useState(0);
  const [ratingQualityHover, setRatingQualityHover] = useState(0);
  const [ratingServiceHover, setRatingServiceHover] = useState(0);
  const [ratingCommunicationHover, setRatingCommunicationHover] = useState(0);
  const [ratingPromptnessHover, setRatingPromptnessHover] = useState(0);
  const [ratingCompletionHover, setRatingCompletionHover] = useState(0);
  const [jobWithLoggedInUser, setJobWithLoggedInUser] = useState(false);
  const [reviewDescription, setReviewDescription] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [filePreviews, setFilePreviews] = useState([]);
  const [filesToRemove, setFilesToRemove] = useState([]);
  const [overallRating, setOverallRating] = useState(0);
  const [ratingCount, setRatingCount] = useState(0);
  const [reviewId, setReviewId] = useState(null);
  const [activeReviewSort, setActiveReviewSort] = useState(null);
  const [sortedData, setSortedData] = useState([]);
  const [files, setFiles] = useState([]);
  const [isAddPortfolioPopup, setIsAddPortfolioPopup] = useState(false);
  const [isViewPortfolioPopup, setIsViewPortfolioPopup] = useState(false);
  const [searchPostcodeValue, setSearchPostcodeValue] = useState(null);
  const fileInputRef = useRef(null);
  const [results, setResults] = useState([]);
  const [workPortfolioTitle, setWorkPortfolioTitle] = useState(null);
  const [workPortfolioDescription, setWorkPortfolioDescription] = useState(null);
  const [workPortfolioSuburb, setWorkPortfolioSuburb] = useState(null);
  const [userType, setUserType] = useState(null);
  const [userId, setUserId] = useState(null);
  const [workPortfolioFiles, setWorkPortfolioFiles] = useState([]);
  const [workPortfolioFilePreviews, setWorkPortfolioFilePreviews] = useState([]);
  const [workPortfolioUploadedFiles, setWorkPortfolioUploadedFiles] = useState([]);
  const [workPortfolioFilesToRemove, setWorkPortfolioFilesToRemove] = useState([]);
  const [workPortfolios, setWorkPortfolios] = useState([]);
  const [editPortfolioStatus, setEditPortfolioStatus] = useState(false);
  const [editPortfolioId, setEditPortfolioId] = useState(null);
  const [workPortfolioExpandedItems, setWorkPortfolioExpandedItems] = useState({});
  const [portfolioFormErrors, setPortfolioFormErrors] = useState({});
  const [loggedBusinessId, setLoggedBusinessId] = useState(null);
  const [businessUserId, setBusinessUserId] = useState(null);
  const navigate = useNavigate();
  const MAX_RESULTS = 20;

  useEffect(() =>
  {
    const fetchBusinessProfile = async () =>
    {
      try
      {
        setLoading(true);
        let businessId;

        if (jwtDecode(localStorage.getItem('token')).BusinessId !== '0' && businessIdFromQuery == null)
          businessId = jwtDecode(localStorage.getItem('token')).BusinessId;
        else
          businessId = businessIdFromQuery;

        const loggedInUserId = jwtDecode(localStorage.getItem('token')).nameid;
        const response = await axios.get(`${API_BASE_URL}/api/BusinessProfile/getBusinessProfile?businessId=${businessId}&userId=${loggedInUserId}`);
        setBusinessProfile(response.data.businesses);
        setCerts(response.data.certifications);
        setServices(response.data.services);
        setJobCompleted(response.data.jobsCompleted);
        setConversationsCount(response.data.conversation);
        setJobQuote(response.data.jobsQuote);
        setReviewOfCustomer(response.data.reviewOfCustomer);
        const token = jwtDecode(localStorage.getItem('token'));
        setLoggedUserName(token.UserName);
        setLoggedUserProfilePic(sessionStorage.getItem('userImage'));
        setJobWithLoggedInUser(response.data.jobWithLoggedInUser);
        setWorkPortfolios(response.data.workPortfolio.model);
        setUserType(token.UserType);
        setBusinessUserId(response.data.businessUserId);
        setUserId(token.nameid);
        if (token.BusinessId)
        {
          const businessId = parseInt(token.BusinessId)
          setLoggedBusinessId(businessId);
        }
      } catch (err)
      {
        showToast('error', 'Failed to fetch business profile');
      } finally
      {
        setLoading(false);
      }
    };

    fetchBusinessProfile();
  }, []);

  // useEffect(() =>
  // {
  //   const loadImages = async () =>
  //   {
  //     try
  //     {
  //       const businessId = jwtDecode(localStorage.getItem('token')).BusinessId;
  //       const response = await axios.get(`${API_BASE_URL}/api/Media/media/${businessId}`);
  //       const sortedFiles = response.data.sort((a, b) => b.mediaId - a.mediaId);
  //       setUploadedFiles(sortedFiles);
  //     } catch (error)
  //     {
  //       console.error('Error loading images', error);
  //     }
  //   };
  //   loadImages();
  // }, []);

  const settings = {
    centerMode: true,
    infinite: true,
    slidesToShow: 2,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    centerPadding: "0",
    responsive: [
      {
        breakpoint: 1800,
        settings: {
          slidesToShow: 2,
          centerPadding: "0",
        },
      },
      {
        breakpoint: 1499,
        settings: {
          slidesToShow: 2,
          centerPadding: "0",
        },
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 1,
          centerPadding: "0",
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          centerPadding: "0",
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerPadding: "0",
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          centerPadding: "0",
        },
      },
    ],
  };

  const handleToggleBusinessReview = (id) =>
  {
    setExpandedItems((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };


  const handleRating = (rate) =>
  {
    setRating(rate);
  };

  const handleCloseModalReview = () =>
  {
    setRating(0);
    setRatingCommunication(0);
    setRatingCompletion(0);
    setRatingPromptness(0);
    setRatingQuality(0);
    setRatingService(0);
    setReviewDescription(null);
    setFiles([]);
    setFilePreviews([]);
    setIsPopupOpen(false);
  }

  const handleBusinessReview = async (isPublish) =>
  {
    setLoading(true);
    const token = localStorage.getItem('token');
    const userId = token ? jwtDecode(token).nameid : null;

    if (!userId)
    {
      alert('User not authenticated. Please log in.');
      setLoading(false);
      return;
    }

    try
    {
      const formData = new FormData();
      if (reviewId != null)
        formData.append('reviewId', reviewId);
      formData.append('businessId', businessProfile?.businessId || '');
      formData.append('jobId', '');
      formData.append('businessName', businessProfile?.businessName || '');
      formData.append('description', reviewDescription || '');
      formData.append('overallRating', rating || 0);
      formData.append('userId', userId);
      formData.append('ratingQuality', ratingQuality || 0);
      formData.append('ratingService', ratingService || 0);
      formData.append('ratingCommunication', ratingCommunication || 0);
      formData.append('ratingPromptness', ratingPromptness || 0);
      formData.append('ratingCompletion', ratingCompletion || 0);

      files.forEach((file) => formData.append('files', file));
      filesToRemove.forEach((fileId) => formData.append('filesToRemove', fileId));

      const endpoint = isPublish
        ? `${API_BASE_URL}/api/BusinessReview/publish`
        : `${API_BASE_URL}/api/BusinessReview/save`;

      const response = await axios.post(endpoint, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.status === 200)
      {
        showToast('success', `${isPublish ? 'Published' : 'Drafted'} successfully!`);
        handleCloseModalReview();
        setFilesToRemove([]);
      }
    } catch (error)
    {
      showToast('Error saving business review:', error);
    } finally
    {
      setLoading(false);
    }
  };

  const handleRetrieveReviewOfBusiness = async (e) =>
  {
    e.stopPropagation();
    setLoading(true);
    try
    {
      let businessId;
      if (jwtDecode(localStorage.getItem('token')).BusinessId !== '0' && businessIdFromQuery == null)
        businessId = jwtDecode(localStorage.getItem('token')).BusinessId;
      else
        businessId = businessIdFromQuery;

      const response = await axios.get(`${API_BASE_URL}/api/BusinessReview/viewReviewDetail?businessId=${businessId}`);
      if (response.status === 200)
      {
        setViewReviewForBusiness(response.data.model.reviewOfBusinesses)
        setOverallRating(response.data.model.overallBusinessRating);
        setRatingCount(response.data.model.ratingCount);
        setIsViewReviewPopup(true);
      }
    }
    catch (error)
    {
      showToast('Error saving business review:', error);
    }
    finally
    {
      setLoading(false);
    }
  }

  const handleFileChange = (e) =>
  {
    setFiles((prev) => [...prev, ...e.target.files]);
    const files = Array.from(e.target.files);
    const previews = files.map((file) => URL.createObjectURL(file));
    setFilePreviews((prev) => [...prev, ...previews]);
  };

  const handleRemoveFile = (index) =>
  {
    const newFilePreviews = filePreviews.filter((_, i) => i !== index);
    setFilePreviews(newFilePreviews);
    const newFiles = files.filter((_, i) => i !== index);
    setFiles(newFiles);
  };

  const handleRemoveUploadedFile = (fileId) =>
  {
    setFilesToRemove([...filesToRemove, fileId]);
    setUploadedFiles(uploadedFiles.filter((file) => file.id !== fileId));
  };

  const handleWriteReviewClick = async (e) =>
  {
    e.stopPropagation();
    setLoading(true);
    try
    {
      const userId = jwtDecode(localStorage.getItem('token')).nameid;
      const response = await axios.get(`${API_BASE_URL}/api/BusinessReview/viewReviewForEdit?businessId=${businessIdFromQuery}&userId=${userId}`);
      if (response.status === 200)
      {
        const data = response.data;
        if (data.model != null)
        {
          setReviewId(data.model.reviewId);
          setRating(data.model.overallRating);
          setReviewDescription(data.model.description);
          setRatingCommunication(data.model.ratingCommunication);
          setRatingCompletion(data.model.ratingCompletion);
          setRatingPromptness(data.model.ratingPromptness);
          setRatingQuality(data.model.ratingQuality);
          setRatingService(data.model.ratingService);
          setUploadedFiles(data.model.mediaUrl);
        }
        // showToast('success', data.message);
      }
    }
    catch (error)
    {
      showToast(error.message);
    }
    finally
    {
      setIsPopupOpen(true);
      setLoading(false);
    }
  }

  const handleClickReviewSort = (tab) =>
  {
    setLoading(true);
    setActiveReviewSort(tab);
    let sortedList = [...viewReviewForBusiness];
    switch (tab)
    {
      case 'latest':
        sortedList = sortedList.sort((a, b) => new Date(b.dateModified) - new Date(a.dateModified));
        break;

      case 'highest':
        sortedList = sortedList.sort((a, b) => b.overallRating - a.overallRating);
        break;

      case 'lowest':
        sortedList = sortedList.sort((a, b) => a.overallRating - b.overallRating);
        break;

      default:
        break;
    }
    setViewReviewForBusiness(sortedList);
    //setSortedData(sortedList);
    setLoading(false);
  }

  const handleClickAddPortfolio = async (e) =>
  {
    setIsAddPortfolioPopup(true);
  }

  const handleclickMorePortfolio = async (e, portfolioId) =>
  {
    setLoading(true);
    try
    {
      if (portfolioId)
      {
        var businessId = jwtDecode(localStorage.getItem("token")).BusinessId;
        var response = await axios.get(`${API_BASE_URL}/api/WorkPortfolio/GetWorkPortfolioDetail?portfolioId=${portfolioId}&businessId=${businessId}`);
        if (response.status === 200)
        {
          let data = response.data.model;
          setWorkPortfolioDescription(data.description);
          setWorkPortfolioTitle(data.title);
          setWorkPortfolioSuburb(data.suburb);
          setSearchPostcodeValue(data.postcode);
          setWorkPortfolioUploadedFiles(data.mediaUrl);
        }
      }
    }
    catch (error)
    {
      console.log(error);
    }
    finally
    {
      setLoading(false);
      setIsViewPortfolioPopup(true);
    }
  }

  const handleSearchPostcodeChange = async (e) =>
  {
    setWorkPortfolioSuburb(null);
    const searchPostcodeValue = e.target.value;
    setSearchPostcodeValue(searchPostcodeValue);

    if (searchPostcodeValue.length > 0)
    {
      try
      {
        const response = await axios.get(`${API_BASE_URL}/api/WorkPortfolio/GetSuburbByPostcode?postcode=${searchPostcodeValue}`);
        setResults(response.data.model.slice(0, MAX_RESULTS));
      } catch (error)
      {
        console.error('Error fetching suburb:', error);
      }
    } else
    {
      setResults([]);
    }
  };

  const validatePortfolioForm = () =>
  {
    const newErrors = {};
    if (!workPortfolioTitle) newErrors.portfolioTitle = 'Title is required';
    if (!searchPostcodeValue) newErrors.portfolioPostcode = 'Postcode is required';
    if (!workPortfolioSuburb) newErrors.portfolioSuburb = 'Suburb is required';
    if (!workPortfolioDescription) newErrors.portfolioDescription = 'Description is required';
    //if (!formData.images) newErrors.images = 'Profile image is required';
    setPortfolioFormErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleClickWorkPortfolioSubmit = async (e) =>
  {
    e.preventDefault();
    if (!validatePortfolioForm()) return;
    setLoading(true);
    try
    {
      const businessId = jwtDecode(localStorage.getItem('token')).BusinessId;
      const formData = new FormData();
      if (businessId != null)
      {
        formData.append('businessId', businessId);
        formData.append('title', workPortfolioTitle);
        formData.append('description', workPortfolioDescription);
        formData.append('postcode', searchPostcodeValue);
        formData.append('suburb', workPortfolioSuburb);
      }
      workPortfolioFiles.forEach((file) => formData.append('files', file));
      workPortfolioFilesToRemove.forEach((fileId) => formData.append('filesToRemove', fileId));

      const endpoint = `${API_BASE_URL}/api/WorkPortfolio/CreateWorkPortfolio`

      const response = await axios.post(endpoint, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.status === 200)
      {
        showToast('success', response.data.message.join(' '));
        setIsAddPortfolioPopup(false);
        handleClearAddWorkPortfolioPopup();
        window.location.reload();
      }
    }
    catch (error)
    {
      showToast(error.message);
    }
    finally
    {
      setLoading(false);
    }
  }

  const handleWorkPortfolioFileChange = (e) =>
  {
    setWorkPortfolioFiles((prev) => [...prev, ...e.target.files]);
    const files = Array.from(e.target.files);
    const previews = files.map((file) => URL.createObjectURL(file));
    setWorkPortfolioFilePreviews((prev) => [...prev, ...previews]);
  };

  const handleWorkPortfolioRemoveFile = (index) =>
  {
    const newFilePreviews = workPortfolioFilePreviews.filter((_, i) => i !== index);
    setWorkPortfolioFilePreviews(newFilePreviews);
    const newFiles = workPortfolioFiles.filter((_, i) => i !== index);
    setWorkPortfolioFiles(newFiles);
  };

  const handleWorkPortfolioRemoveUploadedFile = (fileId) =>
  {
    setWorkPortfolioFilesToRemove([...filesToRemove, fileId]);
    setWorkPortfolioUploadedFiles(workPortfolioUploadedFiles.filter((file) => file.id !== fileId));
  };

  const handleClearAddWorkPortfolioPopup = () =>
  {
    setIsAddPortfolioPopup(false);
    setWorkPortfolioDescription(null);
    setWorkPortfolioTitle(null);
    setWorkPortfolioFiles([]);
    setWorkPortfolioSuburb(null);
    setSearchPostcodeValue(null);
    setWorkPortfolioFilePreviews([]);
    setWorkPortfolioUploadedFiles([]);
    setResults([]);
    setEditPortfolioStatus(false);
  }

  const handleWorkPortfolioEdit = async (portfolioId) =>
  {
    setLoading(true);
    try
    {
      if (portfolioId !== null)
      {
        var businessId = jwtDecode(localStorage.getItem("token")).BusinessId;
        var response = await axios.get(`${API_BASE_URL}/api/WorkPortfolio/GetWorkPortfolioDetail?portfolioId=${portfolioId}&businessId=${businessId}`);
        if (response.status === 200)
        {
          var data = response.data.model;
          setWorkPortfolioDescription(data.description);
          setWorkPortfolioTitle(data.title);
          setSearchPostcodeValue(data.postcode);
          setEditPortfolioId(portfolioId);
          if (data.suburb !== null && data.postcode !== null)
          {
            var suburbData = await axios.get(`${API_BASE_URL}/api/WorkPortfolio/GetSuburbByPostcode?postcode=${data.postcode}`);
            setResults(suburbData.data.model.slice(0, MAX_RESULTS));
            setWorkPortfolioSuburb(data.suburb);
          }

          if (data.mediaUrl !== null)
          {
            setWorkPortfolioUploadedFiles(data.mediaUrl);
          }
          setIsAddPortfolioPopup(true);
          setEditPortfolioStatus(true);
        }
        else
        {
          showToast('error', 'Error fetching portfolio details');
        }
      }
    }
    catch (error)
    {
      console.log(error);
    }
    finally
    {
      setLoading(false);
    }
  }

  const handleWorkPortfolioDelete = async (portfolioId) =>
  {
    try
    {
      if (portfolioId !== null)
      {
        const businessId = jwtDecode(localStorage.getItem("token")).BusinessId;
        const result = await Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
          customClass: "confirmation-popup"
        });
        if (result.isConfirmed)
        {
          const response = await axios.delete(`${API_BASE_URL}/api/WorkPortfolio/DeleteWorkPortfolio?portfolioId=${portfolioId}&businessId=${businessId}`);
          Swal.fire({
            title: "Deleted!",
            text: response.data.message.join(''),
            icon: "success",
            customClass: "confirmation-popup"
          }).then(() =>
          {
            window.location.reload();
          });
        }
      }
    } catch (error)
    {
      console.log(error);
      Swal.fire({
        title: "Error!",
        text: "There was an error deleting the portfolio.",
        icon: "error"
      });
    }
  };

  const handleClickEditWorkPortfolio = async (e) =>
  {
    e.preventDefault();
    setLoading(true);
    try
    {
      const businessId = jwtDecode(localStorage.getItem('token')).BusinessId;
      const formData = new FormData();
      if (businessId != null)
      {
        formData.append('portfolioId', editPortfolioId);
        formData.append('businessId', businessId);
        formData.append('title', workPortfolioTitle);
        formData.append('description', workPortfolioDescription);
        formData.append('postcode', searchPostcodeValue);
        formData.append('suburb', workPortfolioSuburb);
      }
      workPortfolioFiles.forEach((file) => formData.append('files', file));
      workPortfolioFilesToRemove.forEach((fileId) => formData.append('filesToRemove', fileId));

      const endpoint = `${API_BASE_URL}/api/WorkPortfolio/UpdateWorkPortfolio`

      const response = await axios.put(endpoint, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.status === 200)
      {
        showToast('success', response.data.message.join(' '));
        setIsAddPortfolioPopup(false);
        handleClearAddWorkPortfolioPopup();
        window.location.reload();
      }
    }
    catch (error)
    {
      showToast(error.message);
    }
    finally
    {
      setLoading(false);
    }
  };

  var workPortfolio_Settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const handleCloseWorkPortfolioMore = (e) =>
  {
    setIsViewPortfolioPopup(false);
    setWorkPortfolioDescription(null);
    setWorkPortfolioSuburb(null);
    setWorkPortfolioTitle(null);
    setSearchPostcodeValue(null);
    setWorkPortfolioUploadedFiles([]);
  };

  const handleWorkPortfolioToggle = (id) =>
  {
    setWorkPortfolioExpandedItems((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const handleClickMessage = async (e) =>
  {
    try
    {
      setLoading(true);
      const token = localStorage.getItem('token');
      if (token !== null)
      {
        const decodeToken = jwtDecode(token);
        const userId = decodeToken.nameid;

        if (decodeToken.UserType === 'Home')
        {
          const response = await axios.get(`${API_BASE_URL}/api/Chat/NewConversation?businessUserid=${businessUserId}&homeUserId=${userId}`);
          if (response.status === 200)
          {
            const conversationData = response.data;
            localStorage.setItem('chatUserId', businessUserId);
            // setActiveConversation(conversationData);
            if (decodeToken.UserType === "Home")
            {
              navigate('/home_messages', { state: { conversationId: conversationData.conversationId } });
            } else if (decodeToken.UserType === "Business")
            {
              navigate('/business_messages', { state: { conversationId: conversationData.conversationId } });
            }
          }
        }
      } else
      {
        navigate('/login');
      }
    } catch (error)
    {
      console.error(error);
    } finally
    {
      setLoading(false);
    }
  }

  return (
    <>
      {businessProfile && (
        <>
          <DashboardNavbar prefix={'Biz '} />
          {loading ? <Loader /> : null}
          <section className="inner-page-banner text-center profile-banner">
            <div className="container">
              <div className="row">
                <div className="col-sm-12 profile-banner-box">
                  <div className="profile-image-detail">
                    <figure>
                      <img
                        src={businessProfile?.profilePic != null ? businessProfile?.profilePic : EmptyProfileImage}
                        alt="User profile" />
                    </figure>
                    <div>
                      <h2>{businessProfile?.businessName} </h2>
                      <p>{businessProfile?.streetName} {businessProfile?.suburb}</p>
                      <p>{businessProfile?.myState} {businessProfile?.postCode}</p>
                    </div>
                  </div>

                  <div class="profile-banner-right">
                    <div class="profile-rating">
                      Rating Score
                      <StarRating ratings={businessProfile?.overallRating} /> <span> {businessProfile?.overallRating}</span>
                    </div>
                    <div className="profile-action-buttons">
                      {!(userType === "Business" || (userType === "Business" && loggedBusinessId !== businessProfile?.businessId)) ? (
                        <button className="btn" onClick={(e) => handleClickMessage(e)}>
                          <svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M22.68 1.7875C22.06 0.607499 21.03 0.0075 19.65 0.0075C14.22 -0.0025 8.78999 -0.0025 3.35999 0.0075C1.65999 0.0075 0.409988 0.997497 0.0499878 2.5675C0.0399878 2.5975 0.02 2.62751 0 2.64751V13.9775C0.05 14.1475 0.0999731 14.3175 0.159973 14.4875C0.629973 15.8075 1.84 16.6075 3.37 16.6175C3.75999 16.6175 4.15001 16.6175 4.57001 16.6175C4.57001 16.7075 4.57001 16.7775 4.57001 16.8575C4.57001 17.6575 4.58003 18.4475 4.59003 19.2475C4.60003 19.7575 4.96 20.0775 5.44 19.9775C5.58 19.9475 5.72002 19.8675 5.83002 19.7875C7.22002 18.7775 8.61001 17.7675 10.01 16.7575C10.12 16.6775 10.28 16.6275 10.41 16.6275C13.46 16.6175 16.5 16.6175 19.55 16.6275C20.47 16.6275 21.29 16.3775 21.96 15.7775C22.48 15.3175 22.79 14.7575 22.94 14.1075C22.95 14.0675 22.98 14.0275 22.99 13.9875V2.6975C22.9 2.3975 22.83 2.0775 22.68 1.7875ZM21.6 13.3975C21.6 14.5575 20.81 15.2975 19.58 15.2975C16.44 15.2975 13.31 15.2975 10.17 15.2975C9.85998 15.2975 9.60999 15.3775 9.35999 15.5575C8.29999 16.3375 7.22997 17.1075 6.15997 17.8875C6.10997 17.9175 6.05997 17.9575 5.96997 18.0175C5.96997 17.3475 5.96997 16.7175 5.96997 16.0975C5.96997 15.5575 5.70001 15.3075 5.13 15.3075C4.52 15.3075 3.92 15.3175 3.31 15.3075C2.39 15.2975 1.71997 14.8075 1.46997 13.9675C1.41997 13.7875 1.40002 13.5975 1.40002 13.4075C1.40002 10.0175 1.40002 6.62751 1.40002 3.23751C1.40002 2.07751 2.18998 1.33752 3.41998 1.33752C8.79998 1.33752 14.18 1.33752 19.57 1.33752C20.58 1.33752 21.27 1.7975 21.52 2.6675C21.57 2.8475 21.59 3.0375 21.59 3.2275C21.6 6.6275 21.6 10.0075 21.6 13.3975Z" fill="white" />
                          </svg>
                          Message
                        </button>
                      ) : null}
                      {/* <button className="btn">
                        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M24.9979 11.5255V13.5255C24.9779 13.5655 24.9579 13.6055 24.9479 13.6455C24.8879 14.0655 24.8379 14.4855 24.7579 14.8955C23.7679 20.0655 19.5379 24.0955 14.3179 24.8555C14.0179 24.8955 13.7179 24.9455 13.4179 24.9955H11.4679C11.1979 24.9455 10.9179 24.8955 10.6479 24.8555C8.4279 24.5155 6.44788 23.6555 4.68788 22.2555C4.42788 22.0455 4.37792 21.7655 4.54792 21.5255C4.73792 21.2755 5.02788 21.2555 5.31788 21.4855C6.62788 22.5255 8.09791 23.2455 9.71791 23.6555C15.8679 25.1755 22.1079 21.4355 23.6379 15.2955C24.9879 9.87553 22.2479 4.24552 17.1679 2.00552C10.7279 -0.834481 3.28793 2.63553 1.42793 9.42553C0.41793 13.1055 1.13792 16.5055 3.41792 19.5655C3.46792 19.6355 3.51788 19.6955 3.56788 19.7555C3.72788 20.0055 3.6779 20.2855 3.4579 20.4455C3.2479 20.6055 2.95792 20.5855 2.78791 20.3555C2.47792 19.9455 2.1679 19.5455 1.8979 19.1055C0.3779 16.6355 -0.262088 13.9455 0.0979125 11.0655C0.627912 6.84552 2.79792 3.67553 6.47792 1.57553C8.90792 0.185527 11.5479 -0.264466 14.3179 0.145534C19.5179 0.915534 23.6379 4.79551 24.7379 9.96551C24.8379 10.4455 24.8779 10.9255 24.9479 11.4155C24.9479 11.4455 24.9779 11.4755 24.9979 11.5255Z" fill="white" />
                          <path d="M14.6379 21.3955C13.9379 21.5655 13.2179 21.6155 12.4979 21.7255C8.02791 21.6655 4.18792 18.4155 3.44792 14.0055C2.67792 9.33552 5.55795 4.85553 10.1579 3.64553C12.6979 2.97553 15.0979 3.36552 17.3479 4.72552C17.5579 4.85552 17.6979 5.02552 17.6479 5.28552C17.5779 5.65552 17.2079 5.77551 16.8479 5.59551C16.2779 5.30551 15.718 4.98551 15.118 4.77551C10.578 3.19551 5.56795 5.99551 4.53795 10.6855C3.64795 14.7055 5.79794 18.6955 9.64794 20.1555C14.2079 21.8855 19.3879 19.1155 20.4479 14.3555C21.0179 11.7955 20.4779 9.47553 18.8779 7.39553C18.7779 7.26553 18.688 7.08552 18.678 6.91552C18.668 6.71552 18.8079 6.55553 19.0179 6.48553C19.2479 6.41553 19.4379 6.48552 19.5779 6.66552C20.1679 7.37552 20.638 8.16553 20.988 9.01553C23.098 14.2155 20.0979 20.0855 14.6379 21.3955Z" fill="white" />
                          <path d="M14.9879 14.5155C14.9979 13.3355 14.3178 12.4855 12.9978 12.0355V9.10553C13.0578 9.12553 13.1078 9.13552 13.1478 9.15552C13.6878 9.44552 13.9578 9.90553 13.9978 10.5155C14.0178 10.8255 14.2278 11.0155 14.5278 10.9955C14.8078 10.9855 15.0178 10.7655 14.9778 10.4755C14.9278 10.1055 14.8678 9.71552 14.7078 9.37552C14.3778 8.65552 13.7679 8.23553 12.9879 8.04553C12.9879 7.77553 12.9879 7.50553 12.9879 7.23553C12.9879 6.88553 12.7879 6.67554 12.4879 6.67554C12.1879 6.67554 11.9978 6.89551 11.9978 7.24551C11.9978 7.50551 11.9978 7.76552 11.9978 8.03552C10.6878 8.46552 9.9978 9.32552 9.9978 10.5055C9.9978 11.6755 10.6879 12.5255 11.9879 12.9655V15.9055C11.9179 15.8755 11.8678 15.8655 11.8178 15.8355C11.2778 15.5455 11.0279 15.0955 10.9879 14.4955C10.9679 14.1855 10.7578 13.9955 10.4678 14.0155C10.1878 14.0255 10.0078 14.2355 10.0078 14.5355C10.0078 14.9955 10.1279 15.4155 10.3679 15.8055C10.7479 16.4155 11.2978 16.7855 11.9978 16.9555C11.9978 17.2255 11.9978 17.4955 11.9978 17.7655C11.9978 18.1155 12.1978 18.3255 12.4978 18.3255C12.7978 18.3255 12.9879 18.1055 12.9879 17.7555C12.9879 17.4855 12.9879 17.2255 12.9879 16.9655C14.2979 16.5255 14.9879 15.6755 14.9879 14.5155ZM10.9879 10.5055C10.9879 9.87552 11.4079 9.27554 11.9879 9.11554C11.9879 9.15554 11.9978 9.19553 11.9978 9.23553C11.9978 10.1155 11.9978 11.0055 11.9978 11.8955C11.4278 11.7355 10.9979 11.1355 10.9879 10.5055ZM12.9978 15.8855V13.1155C13.5678 13.2655 13.9978 13.8655 13.9978 14.4955C13.9978 15.1255 13.5578 15.7355 12.9978 15.8855Z" fill="white" />
                        </svg>
                        Quote
                      </button> */}
                      <button className="btn">
                        <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M28.5701 25.79C28.4201 25.36 28.3201 24.91 28.1201 24.51C27.7101 23.68 27.0301 23.09 26.1801 22.69C26.2401 22.61 26.2801 22.54 26.3301 22.48C26.7201 21.92 26.94 21.3 26.97 20.62C27.05 19.01 26.0701 17.58 24.5701 17.06C23.0601 16.54 21.41 17.1 20.49 18.45C20.39 18.6 20.3 18.6 20.16 18.56C19.21 18.26 18.25 17.96 17.3 17.67C17.15 17.62 17.0901 17.56 17.0701 17.4C16.9301 16.49 16.45 15.82 15.6 15.45C15.46 15.39 15.4501 15.3 15.4501 15.18C15.4501 14.13 15.4501 13.08 15.4501 12.04C15.4501 11.98 15.46 11.92 15.47 11.86C16.64 11.86 17.8001 11.86 18.9601 11.86C19.4701 11.86 19.8201 11.52 19.8201 11.01C19.8301 10.63 19.8301 10.24 19.8201 9.85999C19.8001 9.01999 19.5401 8.25001 19.0601 7.57001C18.6301 6.97001 18.0701 6.52002 17.4001 6.20002C18.5201 4.22002 18.4001 2.57 17.0301 1.31C15.8101 0.190001 14.0101 0.0600134 12.6201 1.01001C11.9501 1.47001 11.4901 2.08999 11.2501 2.85999C10.8801 4.07999 11.1301 5.19001 11.8801 6.19001C10.6901 6.81001 9.97005 7.63001 9.62005 8.73001C9.40005 9.44001 9.44006 10.17 9.44006 10.9C9.44006 11.54 9.75007 11.86 10.3901 11.86C11.3401 11.86 12.28 11.86 13.23 11.86H13.8V15.39C12.8 15.8 12.26 16.56 12.16 17.63C11.15 17.94 10.1601 18.24 9.18005 18.56C8.96005 18.63 8.86003 18.6 8.72003 18.41C7.74003 17.01 5.93006 16.52 4.38006 17.21C2.82006 17.91 1.97007 19.6 2.39007 21.26C2.52007 21.77 2.79006 22.24 3.00006 22.75C3.00006 22.75 2.95008 22.78 2.90008 22.8C1.88008 23.33 1.19008 24.14 0.830075 25.23C0.610075 25.9 0.660063 26.6 0.630063 27.29C0.610063 27.8 0.770048 28.17 1.24005 28.39H10.3701C10.8501 28.22 11.0501 27.88 11.0301 27.37C11.0101 26.66 11.0601 25.95 10.8401 25.26C10.4901 24.16 9.76008 23.32 8.58008 22.72C9.14008 21.99 9.42005 21.17 9.37005 20.22C9.78005 20.1 10.1801 19.97 10.5901 19.85C11.2201 19.65 11.85 19.45 12.49 19.26C12.57 19.24 12.7001 19.27 12.7601 19.33C13.8501 20.49 15.4001 20.49 16.5101 19.32C16.5601 19.27 16.67 19.23 16.73 19.24C17.78 19.56 18.8301 19.88 19.8901 20.21C19.8501 21.14 20.1101 21.97 20.6901 22.71C19.8901 23.09 19.2701 23.63 18.8301 24.36C18.4601 24.97 18.2701 25.64 18.2501 26.35C18.2401 26.66 18.2701 26.97 18.24 27.28C18.2 27.79 18.38 28.16 18.85 28.37H27.98C28.29 28.27 28.4901 28.05 28.6401 27.77V25.91C28.6101 25.86 28.5801 25.82 28.5701 25.79ZM5.83008 18.51C6.88008 18.51 7.74005 19.37 7.74005 20.42C7.74005 21.47 6.88008 22.33 5.83008 22.33C4.78008 22.33 3.92003 21.48 3.91003 20.43C3.91003 19.37 4.77008 18.51 5.83008 18.51ZM9.36004 26.71H2.31006C2.09006 25.65 2.89007 24.42 4.01007 24.1C4.24007 24.03 4.49004 23.99 4.73004 23.99C5.46004 23.98 6.19003 23.98 6.91003 23.99C8.40003 24 9.49004 25.21 9.36004 26.71ZM14.6401 2C15.6901 2 16.54 2.86002 16.54 3.92002C16.54 4.97002 15.6801 5.82999 14.6301 5.82999C13.5801 5.82999 12.7201 4.98 12.7101 3.93C12.7101 2.86 13.5801 1.99 14.6401 2ZM11.1 10.19C10.95 8.86001 11.86 7.64 13.23 7.5C14.16 7.4 15.11 7.4 16.04 7.5C17.4 7.64 18.2401 8.76 18.1801 10.18H11.1V10.19ZM14.6201 18.51C14.1801 18.5 13.8101 18.13 13.8101 17.69C13.8101 17.25 14.1801 16.88 14.6301 16.87C15.0701 16.87 15.4501 17.24 15.4501 17.68C15.4601 18.13 15.0701 18.52 14.6201 18.51ZM23.4501 18.51C24.5001 18.52 25.35 19.38 25.35 20.43C25.35 21.48 24.4901 22.34 23.4401 22.34C22.3801 22.34 21.5201 21.47 21.5301 20.41C21.5301 19.36 22.3901 18.51 23.4501 18.51ZM26.97 26.7H19.9001C19.7601 25.26 20.8501 24.01 22.2801 23.98C23.0001 23.97 23.7201 23.97 24.4401 23.98C25.9801 23.99 27.06 25.13 26.97 26.7Z" fill="white" />
                        </svg>
                        Social
                      </button>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </section>

          <section class="profile-services-description">
            <div class="container p-ser-flex">
              <div class="profile-desc">
                <h1>Description of Services</h1>
                <p>
                  {businessProfile?.description == "" ? 'No description available.' : businessProfile?.description}
                </p>
              </div>
              <div class="profile-action">
                <div class="call-button">
                  <button type="button">
                    <span>
                      <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21.8408 19.6521C21.0883 18.8868 20.3358 18.1351 19.5697 17.3698C18.4204 16.2219 16.8607 16.2219 15.7114 17.3698C15.3283 17.7525 14.9452 18.1488 14.5621 18.5315C12.0173 17.0282 8.89794 13.8986 7.51609 11.4797C7.94022 11.0697 8.35062 10.6597 8.74739 10.2497C9.7872 9.17012 9.78719 7.61218 8.7337 6.54622C7.94016 5.73991 7.14662 4.94728 6.3394 4.15464C5.25854 3.08867 3.71255 3.08867 2.61801 4.15464C2.24861 4.52362 1.86552 4.87894 1.5098 5.26159C0.387898 6.46422 -0.10468 7.88548 0.0184556 9.51176C0.141591 11.2474 0.647881 12.8873 1.4551 14.418C3.91781 19.0918 7.50241 22.6313 12.3047 24.8862C13.837 25.6105 15.4515 26.0616 17.1754 25.9932C18.2973 25.9522 19.337 25.6789 20.2127 24.9819C20.801 24.5173 21.3209 23.9843 21.8408 23.4513C22.9627 22.3307 22.949 20.7727 21.8408 19.6521ZM20.6095 22.2487C20.3222 22.5493 20.0212 22.8363 19.7338 23.1233C18.995 23.8613 18.0236 24.2576 16.9427 24.2576C15.7387 24.2029 14.5348 23.916 13.3855 23.424C10.6492 22.2624 8.36432 20.4994 6.36679 18.3402C4.95757 16.8232 3.76728 15.1559 2.87797 13.27C2.28966 12.04 1.87921 10.7691 1.76975 9.40245C1.67398 8.22716 2.01602 7.17486 2.87797 6.32756C3.19265 6.01323 3.52104 5.69891 3.8494 5.38459C4.27353 4.9746 4.76605 4.97461 5.19018 5.39826C5.98372 6.1909 6.76354 6.98353 7.54339 7.77617C7.92648 8.15882 7.92648 8.66446 7.54339 9.04712C7.00981 9.59376 6.47624 10.1131 5.94266 10.6598C5.51852 11.0834 5.4775 11.4251 5.79218 11.9444C7.88548 15.4156 10.6765 18.2035 14.138 20.2944C14.6442 20.5951 14.9999 20.5541 15.4104 20.1441C15.9303 19.6248 16.4365 19.1055 16.9564 18.5998C17.4079 18.1488 17.8868 18.1488 18.352 18.5998C19.1045 19.3515 19.8706 20.1168 20.6231 20.8684C21.0609 21.3331 21.061 21.7977 20.6095 22.2487Z" fill="white" />
                        <path d="M26.0001 13.0649C25.9864 13.5842 25.617 13.9806 25.1245 13.9669C24.6456 13.9669 24.2762 13.5842 24.2625 13.0649C24.2625 11.8213 24.0984 10.605 23.6742 9.42971C22.265 5.52118 19.5423 3.04763 15.5199 2.03633C14.74 1.84501 13.9055 1.81764 13.0846 1.74931C12.5373 1.70831 12.1542 1.36667 12.1542 0.861019C12.1542 0.355369 12.5509 4.151e-05 13.0982 4.151e-05C18.4067 -0.0136247 23.2364 3.34828 25.1655 8.4321C25.6854 9.78506 25.9454 11.1927 25.9864 12.655C26.0001 12.8189 26.0001 12.9419 26.0001 13.0649Z" fill="white" />
                        <path d="M20.5272 12.2859C20.5272 12.3953 20.5409 12.5046 20.5272 12.6139C20.4725 13.0649 20.0621 13.4065 19.6243 13.3792C19.1591 13.3519 18.8034 12.9829 18.8034 12.5046C18.7897 11.3976 18.5024 10.3863 17.8594 9.48434C16.8332 8.04939 15.4377 7.29776 13.6728 7.22943C13.1118 7.20209 12.7287 6.84677 12.7424 6.32745C12.7561 5.83547 13.1528 5.49384 13.7138 5.49384C17.0521 5.53483 19.9116 8.02205 20.4315 11.3156C20.4863 11.6299 20.5136 11.9579 20.5409 12.2859C20.5409 12.2859 20.5409 12.2859 20.5272 12.2859Z" fill="white" />
                      </svg>
                    </span>
                    Call Now: <b>{businessProfile?.phone}</b>
                  </button>
                </div>

                <div class="save-dir-buttons">
                  {businessIdFromQuery &&
                    (
                      <button type="button">
                        <svg width="18" height="23" viewBox="0 0 18 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M17.98 2.02263V1.8424C17.96 1.78232 17.9401 1.72225 17.9201 1.66217C17.6705 0.781022 17.1015 0.220296 16.153 0.0400608C16.1331 0.0400608 16.1231 0.0100131 16.1131 0H1.83696C1.68721 0.0500653 1.53746 0.100134 1.39769 0.160213C0.728809 0.440578 0.27956 0.921208 0.0898769 1.6021C0.0699102 1.67219 0.0399431 1.73227 0.00999309 1.79235V2.01263C0.0299598 2.09274 0.0499045 2.16281 0.0499045 2.24292C0.0499045 8.61122 0.0499045 14.9795 0.0499045 21.3479C0.0499045 21.4079 0.0199667 21.468 0 21.5281V21.6583C0.0199667 21.6883 0.0499143 21.7083 0.0598976 21.7383C0.239598 22.3592 0.658889 22.7497 1.29782 22.9399C1.33776 22.9499 1.36775 22.98 1.40769 23H2.06656C2.67554 22.8798 3.07487 22.4693 3.49417 22.0688C5.03161 20.5768 6.57904 19.1049 8.12646 17.613C8.67554 17.0823 9.31448 17.0823 9.87354 17.613C11.3111 18.9948 12.7488 20.3766 14.1963 21.7584C14.6955 22.229 15.1347 22.7797 15.8436 23H16.5025C16.5724 22.98 16.6422 22.9499 16.7021 22.9299C17.3011 22.7497 17.7105 22.3992 17.9101 21.8185C17.9301 21.7584 17.97 21.7083 18 21.6482V21.5181C17.98 21.458 17.95 21.3979 17.95 21.3378C17.95 14.9695 17.95 8.60123 17.95 2.23292C17.9401 2.17285 17.96 2.10273 17.98 2.02263ZM16.3627 21.6482C16.1431 21.7383 15.9933 21.6282 15.8536 21.488C14.1863 19.8859 12.5191 18.2839 10.8619 16.6818C9.7737 15.6404 8.23624 15.6404 7.15804 16.6818C5.50081 18.2738 3.8436 19.8659 2.19635 21.448C2.11648 21.5181 2.03661 21.5982 1.94676 21.6382C1.69718 21.7484 1.46756 21.6182 1.4476 21.3578C1.43761 21.2878 1.4476 21.2277 1.4476 21.1576V2.293C1.4476 1.63214 1.73709 1.35177 2.42595 1.35177H15.624C16.2928 1.35177 16.5923 1.64214 16.5923 2.28298C16.5923 8.5912 16.5923 14.8894 16.5923 21.1977C16.5723 21.3779 16.5724 21.5581 16.3627 21.6482Z" fill="#3C3C3C" />
                        </svg>
                        Save
                      </button>
                    )}
                  {!(userType === "Business" || (userType === "Business" && loggedBusinessId !== businessProfile?.businessId)) ? (
                    <button type='button'>
                      <svg width="18" height="26" viewBox="0 0 18 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.7143 6.86051C16.3168 1.46485 10.6629 -1.40451 5.57025 0.685131C2.28806 2.03664 0.0540391 5.35305 0.00110054 8.93975C-0.0200749 10.3432 0.265796 11.6948 0.731656 13.0047C1.46221 15.0839 2.5104 16.9969 3.7174 18.8266C5.18909 21.0514 6.71367 23.2346 8.22771 25.4282C8.37594 25.6465 8.60891 25.8129 8.79949 26H9.20183C9.39241 25.8129 9.61473 25.6465 9.77354 25.4282C10.1229 24.9604 10.4406 24.4613 10.7794 23.9727C12.2087 21.8519 13.6592 19.7518 15.0462 17.5998C16.1262 15.9156 16.9838 14.1171 17.545 12.1938C18.0426 10.4264 18.1802 8.65906 17.7143 6.86051ZM15.6815 12.9839C14.8451 15.1567 13.6381 17.132 12.3464 19.0449C11.277 20.6251 10.1759 22.1846 9.09591 23.7544C9.07474 23.7856 9.04301 23.8168 9.00066 23.8688C8.84184 23.64 8.69362 23.4321 8.5454 23.2138C7.20076 21.2385 5.8349 19.284 4.53261 17.2775C3.46325 15.6349 2.57391 13.8884 1.981 12.0067C1.45161 10.3121 1.30337 8.61748 1.83275 6.9021C2.84918 3.5649 5.95138 1.36088 9.3818 1.52722C13.0663 1.70396 16.1156 4.67728 16.465 8.40954C16.6132 10.0106 16.2532 11.518 15.6815 12.9839Z" fill="#3C3C3C" />
                      </svg>
                      Directions</button>
                  ) : null}
                </div>
              </div>
            </div>
          </section>

          <section class="profile-page-main-wrapper bottom-hammer-vector">
            <div class="container">
              <div class="profile-page-inner-wrapper">
                <div class="profile-page-left">

                  <div class="profile-card-box profile-interested business-interested">
                    <h2>
                      Services
                    </h2>
                    {services.length > 0 ? (
                      <ul>
                        {services.map((service, index) => (
                          <li key={`service-${index}`}>
                            <img src={RenovationIcon} /><span title={service.name}>{service.name}</span>
                            {/*<p><strong>Description:</strong> {service.description}</p> */}
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p>No services found.</p>
                    )}
                  </div>

                  <div class="profile-card-box profile-interested profile-certification">
                    <h2>
                      Certifications
                    </h2>
                    {certs.length > 0 ? (
                      <ul>
                        {certs.map((certification, index) => (
                          <li key={`cert-${index}`}>
                            <img src={Checkmark} />
                            <span title={certification.name}>{certification.name}</span>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p>No certifications found.</p>
                    )}
                  </div>
                </div>

                <div class="profile-page-right">

                  <div class="business-tags">

                    <div class="business-offers-sec profile-page-sec">
                      <h1>Business Offers</h1>

                      <div class="offers-list">
                        {businessProfile?.afterHours == 1 && (
                          <div class="offer-card">
                            <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M53.7091 23.137C52.0885 12.2746 44.297 3.5931 33.6591 0.872336C32.2047 0.498489 30.688 0.373884 29.2128 0.103884C29.1297 0.083115 29.0673 0.0415385 29.005 0H24.8911C24.2678 0.103846 23.6444 0.207723 23.0003 0.2908C12.2585 1.80695 3.19966 10.0731 0.74795 20.6862C0.457069 21.9531 0.311633 23.2408 0.103861 24.5285C0.0830836 24.6115 0.0415545 24.6946 0 24.7985V29.2223C0.103886 29.8246 0.207739 30.4062 0.290848 31.0085C1.74525 41.4762 9.76527 50.4693 20.0292 53.0654C21.5044 53.4393 23.0211 53.6262 24.5171 53.8962C24.6002 53.917 24.6833 53.9585 24.7872 54H29.005C29.6491 53.8962 30.2932 53.7923 30.9373 53.7093C34.2201 53.2316 37.2951 52.1723 40.1831 50.5523C40.5571 50.3446 40.8688 50.3031 41.2635 50.4277C43.6529 51.0923 46.0215 51.7362 48.4109 52.38C51.0289 53.0862 53.065 51.03 52.3793 48.4131C52.13 47.4992 51.8807 46.5854 51.6314 45.6716C51.2158 44.1347 50.7796 42.5977 50.3848 41.0608C50.3432 40.8739 50.3433 40.6039 50.4264 40.417C52.3587 36.99 53.5222 33.3346 53.8961 29.4092C53.8961 29.3469 53.9584 29.2638 54 29.2015V24.8816C53.8961 24.3208 53.7922 23.7393 53.7091 23.137ZM52.1924 27.7477C52.0885 32.0054 50.9457 35.9931 48.7849 39.6692C48.4525 40.23 48.3902 40.7285 48.5564 41.3515C49.2836 43.8854 49.9485 46.4192 50.6341 48.9531C50.9665 50.1992 50.1562 50.9885 48.9096 50.6562C46.354 49.9708 43.7984 49.2854 41.2428 48.5585C40.6818 48.3923 40.2039 48.4546 39.7053 48.7454C36.9211 50.3862 33.9292 51.4454 30.7295 51.9231C25.7222 52.6708 20.9019 52.0269 16.3517 49.8462C8.60176 46.1077 3.76063 39.96 2.22312 31.4862C0.768709 23.4692 2.84644 16.2831 8.2693 10.177C12.4455 5.48313 17.7437 2.78308 23.9769 2.01462C25.1404 1.86923 26.3247 1.82771 27.322 1.7654C36.2978 2.24309 43.279 6.00231 48.1616 13.3754C51.0289 17.6954 52.3171 22.5554 52.1924 27.7477Z" fill="#002655" />
                              <path d="M40.0791 14.3515C38.7909 14.4346 37.5236 14.5177 36.2354 14.58C35.4874 14.6216 35.1134 14.31 35.0926 13.7285C35.0718 13.1469 35.4459 12.8146 36.1731 12.7731C36.6717 12.7523 37.1911 12.7108 37.8144 12.6692C37.6274 12.5238 37.5235 12.42 37.4196 12.3369C26.8648 4.77691 11.9053 10.6754 9.34965 23.3862C8.43546 27.9762 9.20419 32.2754 11.5936 36.3046C11.8221 36.6992 11.9883 37.1146 11.6559 37.4677C11.4689 37.6754 11.0741 37.8623 10.804 37.8208C10.5339 37.7793 10.2223 37.5092 10.0561 37.26C8.58089 34.8508 7.62514 32.2339 7.33426 29.43C6.62783 22.8462 8.62243 17.1761 13.422 12.6069C20.3616 6.0023 30.958 5.39999 38.6871 11.0492C38.791 11.1323 38.9156 11.2154 39.1026 11.34C39.061 10.6339 39.0195 10.0315 38.9987 9.40844C38.978 8.80613 39.3104 8.43232 39.8298 8.41156C40.37 8.39079 40.7441 8.72308 40.7856 9.30462C40.8687 10.6338 40.9518 11.9631 41.0141 13.3131C41.0557 13.9777 40.7232 14.31 40.0791 14.3515Z" fill="#002655" />
                              <path d="M31.0828 46.3778C25.3899 47.5824 20.1332 46.3986 15.396 43.0547C15.2506 42.9509 15.0843 42.847 14.8973 42.7016C14.9389 43.387 14.9805 44.0101 15.0013 44.6124C15.022 45.2147 14.6896 45.6093 14.1701 45.6301C13.6299 45.6509 13.2351 45.2978 13.1936 44.6747C13.1105 43.387 13.0274 42.1201 12.9651 40.8324C12.9235 40.0639 13.2352 39.7317 14.0039 39.6901C15.2713 39.607 16.5388 39.5239 17.7854 39.4616C18.4503 39.4201 18.8658 39.7524 18.8866 40.3132C18.9074 40.8532 18.5126 41.2063 17.8477 41.2478C17.3283 41.2894 16.8089 41.3101 16.2894 41.3516C16.2687 41.4139 16.2479 41.4555 16.2063 41.5178C17.3491 42.1617 18.4295 42.8886 19.6138 43.4078C29.7531 47.9355 41.3675 42.5147 44.3594 31.8186C45.6892 27.0416 45.066 22.4309 42.635 18.0901C42.5519 17.9448 42.4688 17.7786 42.3649 17.6332C42.0325 17.0517 42.1155 16.5324 42.5726 16.2416C43.0505 15.9509 43.5492 16.117 43.9024 16.6986C45.0244 18.5263 45.8554 20.4994 46.3125 22.6178C48.7019 33.5009 41.9701 44.0724 31.0828 46.3778Z" fill="#002655" />
                              <path d="M19.8008 31.5278C19.78 32.0678 19.3852 32.4001 18.7203 32.4001C17.0374 32.4001 15.3544 32.4001 13.6507 32.4001C12.8611 32.4001 12.5495 32.0262 12.6118 31.237C12.6949 30.2401 13.2559 29.5339 14.0454 29.0147C14.8557 28.4539 15.7076 27.9763 16.5387 27.4363C17.2452 26.9793 17.8477 26.4393 17.9932 25.5255C18.1386 24.5285 17.4737 23.5939 16.5179 23.4485C15.4998 23.2824 14.5856 23.9678 14.4402 25.0062C14.4194 25.1101 14.4194 25.2139 14.3987 25.3178C14.2948 25.8578 13.9208 26.1693 13.4013 26.107C12.9235 26.0447 12.6118 25.6916 12.6118 25.1516C12.6118 23.6147 13.7545 22.1608 15.2713 21.7455C16.7465 21.3508 18.3048 21.9324 19.1774 23.1785C20.0708 24.4662 20.0916 26.2732 19.0735 27.4986C18.4918 28.2047 17.6815 28.7654 16.9335 29.3262C16.331 29.7624 15.6661 30.1155 15.022 30.4893C15.0427 30.5309 15.0635 30.5724 15.0843 30.614C16.2894 30.614 17.5152 30.614 18.7203 30.614C19.3644 30.614 19.8008 30.9878 19.8008 31.5278Z" fill="#002655" />
                              <path d="M26.9897 29.7416C26.9897 30.3023 26.9897 30.8424 26.9897 31.3824C26.9897 32.0054 26.6365 32.4 26.0963 32.4C25.5561 32.4 25.2028 32.0262 25.1821 31.4031C25.1821 30.8838 25.1821 30.3439 25.1821 29.8247C25.1821 29.8039 25.1613 29.8039 25.1197 29.7208H22.294C22.0862 29.7208 21.8785 29.7415 21.6707 29.7208C20.8604 29.6585 20.4864 29.0146 20.8812 28.3085C22.0447 26.2316 23.229 24.1547 24.434 22.0985C24.7249 21.6 25.2444 21.4547 25.7015 21.7247C26.1378 21.9947 26.2625 22.4931 25.9716 23.0124C25.1405 24.487 24.3094 25.9408 23.4783 27.3946C23.3952 27.54 23.3329 27.7062 23.229 27.8931H25.2444C25.2444 27.6024 25.2236 27.3324 25.2444 27.0416C25.2652 26.5016 25.6391 26.1277 26.1378 26.1277C26.6364 26.1277 27.0104 26.5016 27.0312 27.0416C27.052 27.3116 27.0312 27.6023 27.0312 27.9139C27.7584 28.0177 28.8181 27.6647 28.7973 28.8485C28.7349 29.97 27.7169 29.6793 26.9897 29.7416Z" fill="#002655" />
                              <path d="M42.157 22.9915C40.6818 25.9615 39.2067 28.9107 37.7315 31.8599C37.4614 32.3791 36.9627 32.5453 36.5056 32.3168C36.0277 32.0676 35.8823 31.5692 36.1524 31.0084C37.2951 28.7031 38.4587 26.3977 39.6014 24.113C39.7053 23.9053 39.8091 23.7184 39.9338 23.4276C38.8741 23.4276 37.9184 23.4276 36.9627 23.4276C36.5263 23.4276 36.1939 23.2199 36.0485 22.7838C35.9238 22.3892 36.0485 22.0361 36.3809 21.8076C36.5471 21.7038 36.7757 21.6415 36.9627 21.6415C38.3963 21.6207 39.8507 21.6207 41.2844 21.6415C42.0947 21.6415 42.5102 22.2646 42.157 22.9915Z" fill="#002655" />
                              <path d="M34.1786 21.7454C34.0747 22.1608 33.9501 22.7008 33.8254 23.22C33.0566 26.2731 32.2878 29.3469 31.5191 32.4C31.3321 33.1477 30.875 33.4592 30.2932 33.2515C29.7738 33.0646 29.6076 32.6285 29.7738 31.9431C30.1893 30.3023 30.6049 28.6408 30.9997 27C31.4568 25.1723 31.9139 23.3238 32.371 21.4962C32.5164 20.9354 32.9319 20.6446 33.389 20.7069C33.8669 20.7692 34.1786 21.1638 34.1786 21.7454Z" fill="#002655" />
                            </svg>

                            <div class="offer-card-desc">
                              <span>24/7
                              </span>
                              Hrs Emergency
                            </div>

                          </div>
                        )}

                        {businessProfile?.yearsExperience !== 0 && (
                          <div class="offer-card  card-dull-blue">
                            <svg width="48" height="53" viewBox="0 0 48 53" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M37.5699 20.5879C37.3899 19.5879 36.6199 19.0079 35.9799 18.3479C34.6799 16.9979 33.1199 16.9979 31.8199 18.3379C29.1499 21.0879 26.4899 23.8479 23.8299 26.6079C23.1699 27.2879 22.7199 27.2879 22.0699 26.6079C21.1999 25.7079 20.3399 24.7979 19.4499 23.9079C18.3099 22.7579 16.6799 22.7479 15.5399 23.8679C15.1799 24.2179 14.8299 24.5779 14.4899 24.9479C13.4599 26.0679 13.4399 27.6979 14.4999 28.7979C16.6699 31.0679 18.8399 33.3179 21.0399 35.5579C22.1399 36.6879 23.7499 36.6979 24.8499 35.5679C28.8599 31.4479 32.8499 27.3079 36.8499 23.1679C37.3699 22.6279 37.6299 21.9779 37.6599 21.1179C37.6399 21.0079 37.6099 20.7979 37.5699 20.5879ZM35.5599 22.0179C31.6299 26.0979 27.6999 30.1679 23.7599 34.2279C23.2099 34.7979 22.6999 34.7979 22.1499 34.2279C20.0499 32.0679 17.9599 29.9079 15.8699 27.7379C15.2799 27.1179 15.2799 26.6179 15.8599 25.9979C16.1199 25.7279 16.3799 25.4579 16.6399 25.1879C17.2099 24.6079 17.7299 24.5979 18.2899 25.1779C19.1199 26.0179 19.9299 26.8779 20.7599 27.7279C22.1699 29.1879 23.7299 29.1879 25.1199 27.7479C27.7299 25.0379 30.3499 22.3379 32.9699 19.6379C33.7099 18.8779 34.0999 18.8779 34.8399 19.6379C35.0999 19.9079 35.3899 20.1579 35.6199 20.4579C35.7899 20.6679 35.8899 20.9479 36.0399 21.2379C35.8699 21.5179 35.7599 21.8179 35.5599 22.0179Z" fill="#0243A9" />
                              <path d="M48.0099 18.0479C47.8699 23.6879 46.9699 29.1279 44.6899 34.2979C44.5699 34.5579 44.3899 34.8979 44.1599 34.9779C43.8899 35.0779 43.49 35.0179 43.24 34.8579C42.86 34.6179 42.9 34.1979 43.05 33.7879C43.54 32.4779 44.08 31.1879 44.5 29.8479C45.91 25.2979 46.37 20.6179 46.12 15.8579C46.05 14.5579 45.8999 13.2779 45.7699 11.9779C45.6899 11.1679 45.52 10.9879 44.74 10.8479C40.06 9.99794 35.5799 8.51793 31.3899 6.24793C29.1699 5.04793 27.0799 3.61795 24.9599 2.23795C23.9599 1.58795 24.01 1.56793 23 2.24793C21.42 3.31793 19.8199 4.34794 18.2199 5.37794C17.8399 5.62794 17.4299 5.60795 17.0999 5.26795C16.8199 4.97795 16.7699 4.61793 16.9699 4.27793C17.0599 4.11793 17.2299 3.98794 17.3899 3.87794C19.0899 2.73794 20.8099 1.61794 22.5099 0.477941C23.4799 -0.172059 24.55 -0.172072 25.54 0.557928C28.07 2.43793 30.7299 4.07795 33.5699 5.42795C37.2799 7.19795 41.1699 8.41795 45.1999 9.17795C46.5199 9.42795 47.2999 10.2079 47.4399 11.5579C47.6699 13.7379 47.8199 15.8879 48.0099 18.0479Z" fill="#0243A9" />
                              <path d="M20.58 9.53793C19.77 9.35793 18.95 9.17792 18.14 8.99792C16.11 8.53792 14.79 7.34793 14.33 5.25793C14.13 4.36793 13.92 3.46793 13.74 2.56793C13.64 2.07793 13.38 1.80792 12.89 1.74792C12.4 1.78792 12.13 2.06794 12.02 2.54794C11.79 3.59794 11.56 4.65794 11.29 5.69794C10.86 7.32794 9.80995 8.36792 8.19995 8.80792C7.20995 9.07792 6.19995 9.29792 5.19995 9.52792C4.63995 9.65792 4.34997 9.92792 4.34997 10.3979C4.33997 10.8679 4.63999 11.1579 5.17999 11.2879C6.21999 11.5279 7.25997 11.7479 8.27997 12.0379C9.81997 12.4679 10.84 13.4979 11.27 15.0579C11.56 16.0979 11.7899 17.1479 12.0099 18.2079C12.1199 18.7079 12.35 19.0379 12.87 19.0679C13.33 19.0979 13.62 18.7879 13.75 18.2279C13.98 17.1979 14.21 16.1579 14.48 15.1379C14.91 13.5279 15.93 12.4779 17.52 12.0379C18.53 11.7579 19.5499 11.5279 20.5699 11.3079C21.0599 11.1979 21.39 10.9679 21.42 10.4279C21.44 9.95795 21.14 9.65793 20.58 9.53793ZM12.8799 14.4279C12.1999 12.3879 10.9499 11.0979 8.93994 10.4179C10.9099 9.71794 12.21 8.45792 12.87 6.39792C13.55 8.41792 14.81 9.72792 16.83 10.3979C14.85 11.0879 13.5499 12.3479 12.8799 14.4279Z" fill="#0243A9" />
                              <path d="M47.1 40.708C46.28 40.538 45.47 40.348 44.65 40.178C42.6 39.728 41.27 38.518 40.8 36.408C40.61 35.548 40.41 34.688 40.23 33.828C40.1 33.208 39.82 32.918 39.35 32.928C38.88 32.938 38.63 33.218 38.48 33.848C38.25 34.868 38.03 35.888 37.76 36.888C37.32 38.488 36.29 39.538 34.7 39.968C33.69 40.248 32.67 40.468 31.65 40.708C31.1 40.838 30.81 41.128 30.82 41.598C30.83 42.058 31.11 42.338 31.67 42.468C32.69 42.708 33.71 42.928 34.72 43.208C36.28 43.638 37.31 44.668 37.75 46.248C38.04 47.288 38.25 48.348 38.49 49.398C38.62 49.968 38.9 50.268 39.36 50.238C39.89 50.208 40.12 49.878 40.22 49.378C40.43 48.358 40.66 47.338 40.93 46.338C41.36 44.708 42.39 43.648 44 43.208C45.03 42.928 46.07 42.698 47.11 42.468C47.59 42.358 47.86 42.088 47.9 41.588C47.85 41.078 47.58 40.808 47.1 40.708ZM39.36 45.608C38.68 43.568 37.43 42.278 35.42 41.598C37.39 40.898 38.69 39.638 39.35 37.578C40.03 39.598 41.29 40.908 43.31 41.578C41.34 42.258 40.03 43.518 39.36 45.608Z" fill="#0243A9" />
                              <path d="M28.03 44.3679C27.01 44.8379 25.9799 45.2579 24.9499 45.7079C24.2899 45.9879 23.65 45.9579 22.98 45.7079C14.09 42.3479 8.61999 35.9079 6.24999 26.6579C5.54999 23.9079 5.24994 21.0979 5.25994 18.2679C5.25994 17.3279 5.23995 16.3979 5.26995 15.4579C5.27995 15.1779 5.37995 14.8879 5.51995 14.6479C5.72995 14.2979 6.06997 14.1479 6.47997 14.2879C6.90997 14.4379 7.09994 14.7579 7.06994 15.1979C7.00994 16.3979 6.85996 17.5979 6.89996 18.7979C7.01996 22.9679 7.74994 27.0279 9.44994 30.8579C12.2799 37.2779 17.0199 41.6379 23.5099 44.0479C23.7799 44.1479 24.15 44.1479 24.42 44.0379C25.38 43.6579 26.31 43.2279 27.25 42.8079C27.87 42.5279 28.34 42.6279 28.58 43.1179C28.84 43.6079 28.65 44.0879 28.03 44.3679Z" fill="#0243A9" />
                              <path d="M6.59998 38.7279C6.17998 38.9879 5.67997 38.8779 5.40997 38.3879C4.70997 37.1179 3.97 35.8679 3.37 34.5479C1.4 30.1979 0.409963 25.5979 0.149963 20.8279C0.0999634 19.8779 0.06 18.9179 0 17.5179C0.11 16.0979 0.239954 14.2279 0.389954 12.3579C0.409954 12.1279 0.469966 11.8879 0.589966 11.6979C0.819966 11.3479 1.16995 11.2379 1.56995 11.3879C1.99995 11.5479 2.14999 11.8979 2.10999 12.3379C2.00999 13.4879 1.87995 14.6379 1.81995 15.7879C1.52995 21.6079 2.23994 27.2879 4.43994 32.7079C5.03994 34.1779 5.83999 35.5679 6.54999 36.9979C6.63999 37.1779 6.75998 37.3379 6.84998 37.5079C7.12998 37.9779 7.01998 38.4679 6.59998 38.7279Z" fill="#0243A9" />
                              <path d="M34.18 47.278C33.13 47.958 32.0901 48.638 31.0001 49.248C29.0401 50.358 26.96 51.178 24.82 51.828C24.55 51.908 24.27 51.948 23.88 52.018C23.28 51.838 22.6 51.658 21.93 51.428C17.99 50.098 14.45 48.058 11.3 45.318C11.25 45.268 11.19 45.228 11.14 45.178C10.74 44.798 10.68 44.308 10.99 43.928C11.31 43.548 11.79 43.508 12.23 43.858C12.83 44.338 13.41 44.848 14.02 45.308C16.92 47.508 20.11 49.128 23.59 50.128C23.87 50.208 24.23 50.188 24.51 50.098C27.47 49.198 30.24 47.888 32.8 46.128C32.95 46.028 33.09 45.918 33.24 45.828C33.71 45.548 34.19 45.638 34.46 46.048C34.72 46.468 34.63 46.978 34.18 47.278Z" fill="#0243A9" />
                              <path d="M42.75 18.4379C42.71 22.2679 42.0599 25.9879 40.8499 29.6179C40.6399 30.2479 40.1999 30.5079 39.6799 30.3279C39.2099 30.1579 39.0299 29.6779 39.2399 29.0679C40.6199 24.9279 41.2299 20.6679 41.0699 16.3079C41.0499 15.8279 40.9899 15.3979 40.6299 15.0279C40.2999 14.6879 40.3599 14.1779 40.6799 13.8579C40.9999 13.5479 41.4799 13.5379 41.8399 13.8479C42.4599 14.3879 42.74 15.0979 42.75 15.9079C42.76 16.7379 42.75 17.5879 42.75 18.4379Z" fill="#0243A9" />
                              <path d="M33.3 11.108C33.28 12.008 32.65 12.378 31.98 12.038C29.92 10.998 27.88 9.91795 25.84 8.84795C25.51 8.67795 25.2 8.46795 24.89 8.25795C24.46 7.95795 24.04 7.74796 23.46 7.91796C23.02 8.04796 22.66 7.77795 22.53 7.31795C22.4 6.85795 22.58 6.49796 23.01 6.29796C23.76 5.95796 24.52 5.98797 25.2 6.42797C27.62 7.96797 30.13 9.33796 32.74 10.518C33.01 10.638 33.19 10.978 33.3 11.108Z" fill="#0243A9" />
                              <path d="M38.3 13.018C38.29 13.748 37.82 14.178 37.3 14.048C36.81 13.928 36.32 13.7579 35.85 13.5579C35.43 13.3779 35.24 13.0279 35.35 12.5579C35.46 12.0979 35.85 11.8279 36.32 11.9379C36.85 12.0679 37.38 12.238 37.86 12.478C38.1 12.588 38.22 12.908 38.3 13.018Z" fill="#0243A9" />
                              <path d="M9.99999 42.0879C9.84999 42.2579 9.68994 42.5979 9.44994 42.6979C9.19994 42.7879 8.77995 42.7379 8.57995 42.5779C8.19995 42.2679 7.88997 41.8579 7.59997 41.4479C7.35997 41.0979 7.38996 40.658 7.71996 40.428C7.96996 40.258 8.49996 40.1179 8.65996 40.2579C9.14996 40.6779 9.51997 41.2379 9.91997 41.7479C9.96997 41.7979 9.95999 41.8779 9.99999 42.0879Z" fill="#0243A9" />
                            </svg>

                            <div class="offer-card-desc">
                              <span>{businessProfile?.yearsExperience} Yrs
                              </span>
                              Experience
                            </div>
                          </div>
                        )}

                        {businessProfile?.fullyInsured && (
                          <div class="offer-card card-blue">
                            <svg width="48" height="53" viewBox="0 0 48 53" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M37.5699 20.5879C37.3899 19.5879 36.6199 19.0079 35.9799 18.3479C34.6799 16.9979 33.1199 16.9979 31.8199 18.3379C29.1499 21.0879 26.4899 23.8479 23.8299 26.6079C23.1699 27.2879 22.7199 27.2879 22.0699 26.6079C21.1999 25.7079 20.3399 24.7979 19.4499 23.9079C18.3099 22.7579 16.6799 22.7479 15.5399 23.8679C15.1799 24.2179 14.8299 24.5779 14.4899 24.9479C13.4599 26.0679 13.4399 27.6979 14.4999 28.7979C16.6699 31.0679 18.8399 33.3179 21.0399 35.5579C22.1399 36.6879 23.7499 36.6979 24.8499 35.5679C28.8599 31.4479 32.8499 27.3079 36.8499 23.1679C37.3699 22.6279 37.6299 21.9779 37.6599 21.1179C37.6399 21.0079 37.6099 20.7979 37.5699 20.5879ZM35.5599 22.0179C31.6299 26.0979 27.6999 30.1679 23.7599 34.2279C23.2099 34.7979 22.6999 34.7979 22.1499 34.2279C20.0499 32.0679 17.9599 29.9079 15.8699 27.7379C15.2799 27.1179 15.2799 26.6179 15.8599 25.9979C16.1199 25.7279 16.3799 25.4579 16.6399 25.1879C17.2099 24.6079 17.7299 24.5979 18.2899 25.1779C19.1199 26.0179 19.9299 26.8779 20.7599 27.7279C22.1699 29.1879 23.7299 29.1879 25.1199 27.7479C27.7299 25.0379 30.3499 22.3379 32.9699 19.6379C33.7099 18.8779 34.0999 18.8779 34.8399 19.6379C35.0999 19.9079 35.3899 20.1579 35.6199 20.4579C35.7899 20.6679 35.8899 20.9479 36.0399 21.2379C35.8699 21.5179 35.7599 21.8179 35.5599 22.0179Z" fill="#0243A9" />
                              <path d="M48.0099 18.0479C47.8699 23.6879 46.9699 29.1279 44.6899 34.2979C44.5699 34.5579 44.3899 34.8979 44.1599 34.9779C43.8899 35.0779 43.49 35.0179 43.24 34.8579C42.86 34.6179 42.9 34.1979 43.05 33.7879C43.54 32.4779 44.08 31.1879 44.5 29.8479C45.91 25.2979 46.37 20.6179 46.12 15.8579C46.05 14.5579 45.8999 13.2779 45.7699 11.9779C45.6899 11.1679 45.52 10.9879 44.74 10.8479C40.06 9.99794 35.5799 8.51793 31.3899 6.24793C29.1699 5.04793 27.0799 3.61795 24.9599 2.23795C23.9599 1.58795 24.01 1.56793 23 2.24793C21.42 3.31793 19.8199 4.34794 18.2199 5.37794C17.8399 5.62794 17.4299 5.60795 17.0999 5.26795C16.8199 4.97795 16.7699 4.61793 16.9699 4.27793C17.0599 4.11793 17.2299 3.98794 17.3899 3.87794C19.0899 2.73794 20.8099 1.61794 22.5099 0.477941C23.4799 -0.172059 24.55 -0.172072 25.54 0.557928C28.07 2.43793 30.7299 4.07795 33.5699 5.42795C37.2799 7.19795 41.1699 8.41795 45.1999 9.17795C46.5199 9.42795 47.2999 10.2079 47.4399 11.5579C47.6699 13.7379 47.8199 15.8879 48.0099 18.0479Z" fill="#0243A9" />
                              <path d="M20.58 9.53793C19.77 9.35793 18.95 9.17792 18.14 8.99792C16.11 8.53792 14.79 7.34793 14.33 5.25793C14.13 4.36793 13.92 3.46793 13.74 2.56793C13.64 2.07793 13.38 1.80792 12.89 1.74792C12.4 1.78792 12.13 2.06794 12.02 2.54794C11.79 3.59794 11.56 4.65794 11.29 5.69794C10.86 7.32794 9.80995 8.36792 8.19995 8.80792C7.20995 9.07792 6.19995 9.29792 5.19995 9.52792C4.63995 9.65792 4.34997 9.92792 4.34997 10.3979C4.33997 10.8679 4.63999 11.1579 5.17999 11.2879C6.21999 11.5279 7.25997 11.7479 8.27997 12.0379C9.81997 12.4679 10.84 13.4979 11.27 15.0579C11.56 16.0979 11.7899 17.1479 12.0099 18.2079C12.1199 18.7079 12.35 19.0379 12.87 19.0679C13.33 19.0979 13.62 18.7879 13.75 18.2279C13.98 17.1979 14.21 16.1579 14.48 15.1379C14.91 13.5279 15.93 12.4779 17.52 12.0379C18.53 11.7579 19.5499 11.5279 20.5699 11.3079C21.0599 11.1979 21.39 10.9679 21.42 10.4279C21.44 9.95795 21.14 9.65793 20.58 9.53793ZM12.8799 14.4279C12.1999 12.3879 10.9499 11.0979 8.93994 10.4179C10.9099 9.71794 12.21 8.45792 12.87 6.39792C13.55 8.41792 14.81 9.72792 16.83 10.3979C14.85 11.0879 13.5499 12.3479 12.8799 14.4279Z" fill="#0243A9" />
                              <path d="M47.1 40.708C46.28 40.538 45.47 40.348 44.65 40.178C42.6 39.728 41.27 38.518 40.8 36.408C40.61 35.548 40.41 34.688 40.23 33.828C40.1 33.208 39.82 32.918 39.35 32.928C38.88 32.938 38.63 33.218 38.48 33.848C38.25 34.868 38.03 35.888 37.76 36.888C37.32 38.488 36.29 39.538 34.7 39.968C33.69 40.248 32.67 40.468 31.65 40.708C31.1 40.838 30.81 41.128 30.82 41.598C30.83 42.058 31.11 42.338 31.67 42.468C32.69 42.708 33.71 42.928 34.72 43.208C36.28 43.638 37.31 44.668 37.75 46.248C38.04 47.288 38.25 48.348 38.49 49.398C38.62 49.968 38.9 50.268 39.36 50.238C39.89 50.208 40.12 49.878 40.22 49.378C40.43 48.358 40.66 47.338 40.93 46.338C41.36 44.708 42.39 43.648 44 43.208C45.03 42.928 46.07 42.698 47.11 42.468C47.59 42.358 47.86 42.088 47.9 41.588C47.85 41.078 47.58 40.808 47.1 40.708ZM39.36 45.608C38.68 43.568 37.43 42.278 35.42 41.598C37.39 40.898 38.69 39.638 39.35 37.578C40.03 39.598 41.29 40.908 43.31 41.578C41.34 42.258 40.03 43.518 39.36 45.608Z" fill="#0243A9" />
                              <path d="M28.03 44.3679C27.01 44.8379 25.9799 45.2579 24.9499 45.7079C24.2899 45.9879 23.65 45.9579 22.98 45.7079C14.09 42.3479 8.61999 35.9079 6.24999 26.6579C5.54999 23.9079 5.24994 21.0979 5.25994 18.2679C5.25994 17.3279 5.23995 16.3979 5.26995 15.4579C5.27995 15.1779 5.37995 14.8879 5.51995 14.6479C5.72995 14.2979 6.06997 14.1479 6.47997 14.2879C6.90997 14.4379 7.09994 14.7579 7.06994 15.1979C7.00994 16.3979 6.85996 17.5979 6.89996 18.7979C7.01996 22.9679 7.74994 27.0279 9.44994 30.8579C12.2799 37.2779 17.0199 41.6379 23.5099 44.0479C23.7799 44.1479 24.15 44.1479 24.42 44.0379C25.38 43.6579 26.31 43.2279 27.25 42.8079C27.87 42.5279 28.34 42.6279 28.58 43.1179C28.84 43.6079 28.65 44.0879 28.03 44.3679Z" fill="#0243A9" />
                              <path d="M6.59998 38.7279C6.17998 38.9879 5.67997 38.8779 5.40997 38.3879C4.70997 37.1179 3.97 35.8679 3.37 34.5479C1.4 30.1979 0.409963 25.5979 0.149963 20.8279C0.0999634 19.8779 0.06 18.9179 0 17.5179C0.11 16.0979 0.239954 14.2279 0.389954 12.3579C0.409954 12.1279 0.469966 11.8879 0.589966 11.6979C0.819966 11.3479 1.16995 11.2379 1.56995 11.3879C1.99995 11.5479 2.14999 11.8979 2.10999 12.3379C2.00999 13.4879 1.87995 14.6379 1.81995 15.7879C1.52995 21.6079 2.23994 27.2879 4.43994 32.7079C5.03994 34.1779 5.83999 35.5679 6.54999 36.9979C6.63999 37.1779 6.75998 37.3379 6.84998 37.5079C7.12998 37.9779 7.01998 38.4679 6.59998 38.7279Z" fill="#0243A9" />
                              <path d="M34.18 47.278C33.13 47.958 32.0901 48.638 31.0001 49.248C29.0401 50.358 26.96 51.178 24.82 51.828C24.55 51.908 24.27 51.948 23.88 52.018C23.28 51.838 22.6 51.658 21.93 51.428C17.99 50.098 14.45 48.058 11.3 45.318C11.25 45.268 11.19 45.228 11.14 45.178C10.74 44.798 10.68 44.308 10.99 43.928C11.31 43.548 11.79 43.508 12.23 43.858C12.83 44.338 13.41 44.848 14.02 45.308C16.92 47.508 20.11 49.128 23.59 50.128C23.87 50.208 24.23 50.188 24.51 50.098C27.47 49.198 30.24 47.888 32.8 46.128C32.95 46.028 33.09 45.918 33.24 45.828C33.71 45.548 34.19 45.638 34.46 46.048C34.72 46.468 34.63 46.978 34.18 47.278Z" fill="#0243A9" />
                              <path d="M42.75 18.4379C42.71 22.2679 42.0599 25.9879 40.8499 29.6179C40.6399 30.2479 40.1999 30.5079 39.6799 30.3279C39.2099 30.1579 39.0299 29.6779 39.2399 29.0679C40.6199 24.9279 41.2299 20.6679 41.0699 16.3079C41.0499 15.8279 40.9899 15.3979 40.6299 15.0279C40.2999 14.6879 40.3599 14.1779 40.6799 13.8579C40.9999 13.5479 41.4799 13.5379 41.8399 13.8479C42.4599 14.3879 42.74 15.0979 42.75 15.9079C42.76 16.7379 42.75 17.5879 42.75 18.4379Z" fill="#0243A9" />
                              <path d="M33.3 11.108C33.28 12.008 32.65 12.378 31.98 12.038C29.92 10.998 27.88 9.91795 25.84 8.84795C25.51 8.67795 25.2 8.46795 24.89 8.25795C24.46 7.95795 24.04 7.74796 23.46 7.91796C23.02 8.04796 22.66 7.77795 22.53 7.31795C22.4 6.85795 22.58 6.49796 23.01 6.29796C23.76 5.95796 24.52 5.98797 25.2 6.42797C27.62 7.96797 30.13 9.33796 32.74 10.518C33.01 10.638 33.19 10.978 33.3 11.108Z" fill="#0243A9" />
                              <path d="M38.3 13.018C38.29 13.748 37.82 14.178 37.3 14.048C36.81 13.928 36.32 13.7579 35.85 13.5579C35.43 13.3779 35.24 13.0279 35.35 12.5579C35.46 12.0979 35.85 11.8279 36.32 11.9379C36.85 12.0679 37.38 12.238 37.86 12.478C38.1 12.588 38.22 12.908 38.3 13.018Z" fill="#0243A9" />
                              <path d="M9.99999 42.0879C9.84999 42.2579 9.68994 42.5979 9.44994 42.6979C9.19994 42.7879 8.77995 42.7379 8.57995 42.5779C8.19995 42.2679 7.88997 41.8579 7.59997 41.4479C7.35997 41.0979 7.38996 40.658 7.71996 40.428C7.96996 40.258 8.49996 40.1179 8.65996 40.2579C9.14996 40.6779 9.51997 41.2379 9.91997 41.7479C9.96997 41.7979 9.95999 41.8779 9.99999 42.0879Z" fill="#0243A9" />
                            </svg>

                            <div class="offer-card-desc">
                              <span>Fully Insured
                              </span>
                            </div>

                          </div>
                        )}
                      </div>
                    </div>


                    <div class="business-offers-sec profile-page-sec">
                      <h1>Statistics / Badges</h1>

                      <div class="offers-list">
                        <div class="offer-card">
                          <svg width="54" height="46" viewBox="0 0 54 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M53.8619 14.1622C53.2467 11.9982 51.8532 10.9162 49.6561 10.9162C47.798 10.9162 45.9399 10.9162 44.0692 10.9162H41.2946V10.3441C41.2946 8.72739 41.3197 7.11064 41.2946 5.49388C41.2444 3.0563 39.5746 1.01669 37.2268 0.668466C36.0969 0.50679 34.9168 0.581427 33.7617 0.56899C33.3851 0.56899 33.0712 0.556555 32.7825 0.220766C32.6444 0.0590906 32.3054 0.00932746 32.0669 0.00932746C28.6771 -0.00310915 25.2872 -0.00310915 21.8974 0.00932746C21.6715 0.00932746 21.3577 0.0217701 21.2572 0.171009C20.8806 0.68091 20.3658 0.56899 19.8762 0.56899C19.1354 0.56899 18.3947 0.56899 17.6665 0.56899C14.7538 0.56899 12.6697 2.72053 12.6572 5.70532C12.6446 7.28477 12.6572 8.86421 12.6572 10.4437C12.6572 10.5929 12.6447 10.7545 12.6321 10.9162C9.70684 10.9162 6.81919 10.9038 3.94415 10.9287C1.78473 10.9535 0.0270518 12.7444 0.014497 14.9457C-0.0106125 18.9005 0.00194223 22.8554 0.014497 26.8102C0.0270518 28.6757 1.29514 30.28 3.05281 30.7278C3.26624 30.7775 3.47962 30.8148 3.7056 30.8645C3.7056 34.9064 3.74325 38.8862 3.69304 42.8783C3.66793 44.6319 4.84813 46.0124 6.73134 45.9999C20.2528 45.9626 33.7743 45.9875 47.3084 45.9875C49.2292 45.9875 50.2964 44.8806 50.2964 42.9156V30.8645C50.422 30.8272 50.4847 30.8024 50.56 30.7899C52.2675 30.479 53.3472 29.4592 53.8745 27.7803C53.8996 27.6932 53.9623 27.6062 54 27.5191V14.2493C53.9247 14.2244 53.8745 14.1995 53.8619 14.1622ZM33.1967 1.8002C34.5903 1.86239 36.009 1.80019 37.3649 2.02405C38.8087 2.26035 39.9261 3.66569 39.9889 5.22027C40.0768 7.0982 40.014 8.97612 40.014 10.8914H37.7039C37.6914 10.7172 37.6788 10.5556 37.6788 10.3815C37.6788 8.86419 37.6788 7.35938 37.6788 5.85455C37.6788 4.76013 37.2143 4.27507 36.1346 4.27507C35.1679 4.26264 34.2137 4.27507 33.2093 4.27507V1.8002H33.1967ZM22.0607 1.3276H31.8659V4.82229H22.0607V1.3276ZM22.3495 6.14057H31.8283C32.2803 6.14057 32.7072 6.10326 33.0085 5.68042C33.0712 5.59336 33.2093 5.55604 33.3223 5.55604C34.3267 5.54361 35.3185 5.55604 36.3606 5.55604V10.8789H17.5535V5.55604C18.6207 5.55604 19.6627 5.55604 20.7173 5.55604C20.7801 5.55604 20.868 5.59336 20.8931 5.64311C21.2572 6.19032 21.7971 6.153 22.3495 6.14057ZM13.9001 5.69287C13.9126 3.4294 15.4444 1.86237 17.6414 1.86237H20.7173V4.26266C19.738 4.26266 18.7839 4.26266 17.8172 4.26266C16.6872 4.26266 16.2604 4.71038 16.2604 5.85455V10.8789H13.9378C13.9252 10.7545 13.9126 10.6178 13.9126 10.481C13.9001 8.88908 13.9001 7.28475 13.9001 5.69287ZM48.9279 43.5748C48.8275 44.2463 48.3002 44.6443 47.6222 44.6816C47.4841 44.6941 47.346 44.6941 47.2079 44.6941H6.74391C5.6642 44.6941 5.04897 44.2464 4.97365 43.3634C4.92343 42.8908 4.96108 42.4057 4.96108 41.8958H48.953C48.9405 42.4555 49.0032 43.0276 48.9279 43.5748ZM48.9781 40.5527H4.98621V30.9019H8.04958C8.2379 31.9838 8.41363 32.0958 10.2843 32.2823C10.2843 33.2897 10.2843 34.3095 10.2843 35.3293C10.2717 37.0082 10.1965 37.0331 11.9165 37.0207C13.059 37.0082 14.2014 37.0207 15.3439 37.0207C16.0093 37.0207 16.2102 36.8093 16.2227 36.1128V32.2574C17.2522 32.2699 18.3194 32.3694 18.4198 30.8894H35.5194C35.6324 32.2948 36.6368 32.3072 37.7416 32.245V32.9912C37.7416 34.0607 37.7416 35.1427 37.7416 36.2247C37.7416 36.7719 37.9676 37.0082 38.5075 37.0082C39.9638 37.0207 41.4201 37.0207 42.8765 37.0082C43.454 37.0082 43.6549 36.7844 43.6674 36.175C43.68 34.8816 43.6674 33.5882 43.6674 32.245C44.6593 32.2326 45.7515 32.3694 45.8645 30.877H48.9781V40.5527ZM17.0388 29.5463V30.8645H9.39295V29.5463H17.0388ZM11.5649 28.1285V24.7209H14.9045V28.1285H11.5649ZM14.917 32.2823V35.69H11.5775V32.2823H14.917ZM44.5589 29.5463V30.8521H36.8878V29.5463H44.5589ZM39.0222 28.1534V24.7458H42.3743V28.1534H39.0222ZM42.3743 32.2823V35.6651H39.0096V32.2823H42.3743ZM52.6943 26.4496C52.6943 28.4146 51.5393 29.5712 49.5933 29.5587C48.3629 29.5463 47.1326 29.5587 45.8645 29.5587C45.8645 28.9618 45.6762 28.4767 45.1489 28.3026C44.6969 28.1534 44.1948 28.1783 43.68 28.1161C43.68 26.8724 43.68 25.6163 43.68 24.3602C43.68 23.5643 43.5294 23.415 42.7635 23.415C41.4076 23.415 40.0517 23.415 38.7083 23.415C37.8922 23.415 37.7416 23.5643 37.7416 24.4348V28.1782C36.6996 28.1409 35.645 28.0663 35.532 29.5338H18.4324C18.332 28.0912 17.2899 28.1161 16.2102 28.1907V24.3726C16.2102 23.5891 16.047 23.415 15.2937 23.415C13.9252 23.415 12.5567 23.415 11.1757 23.415C10.4099 23.415 10.2592 23.5643 10.2592 24.3726V28.1161C9.74449 28.1783 9.2423 28.1658 8.77778 28.3151C8.26303 28.4767 8.06216 28.9618 8.07471 29.5463C6.59325 29.5463 5.11176 29.6333 3.65541 29.5214C2.21161 29.4095 1.24492 28.1783 1.24492 26.6859C1.23236 22.8554 1.24492 19.0249 1.24492 15.1944C1.24492 13.416 2.39995 12.2221 4.14506 12.2221C15.0426 12.2221 25.9275 12.2221 36.8251 12.2221C41.0937 12.2221 45.3623 12.2221 49.631 12.2221C51.5895 12.2221 52.6943 13.3538 52.6943 15.3685C52.6943 19.0498 52.6943 22.7559 52.6943 26.4496Z" fill="#002655" />
                            <path d="M36.348 13.8264C33.2219 13.8264 30.0958 13.8264 26.9696 13.8264C23.8184 13.8264 20.6797 13.8264 17.541 13.8264C16.8003 13.8264 16.6245 14.0005 16.6245 14.7343V20.878C16.6245 21.5993 16.8128 21.7858 17.541 21.7858H36.3983C37.1139 21.7858 37.3147 21.5868 37.3147 20.8655V14.8338C37.3147 13.9757 37.1641 13.8264 36.348 13.8264ZM36.0091 20.4676H17.905V15.1447H36.0091V20.4676Z" fill="#002655" />
                          </svg>
                          <div class="offer-card-desc">
                            <span>{jobCompleted}
                            </span>
                            Job Complete
                          </div>
                        </div>

                        <div class="offer-card card-blue">
                          <svg width="52" height="53" viewBox="0 0 52 53" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M51.9975 6.55189V27.9019C51.9375 28.0719 51.8475 28.2319 51.8175 28.4019C51.0475 31.8419 48.1075 34.2619 44.6175 34.3019C44.0775 34.3119 43.5475 34.3019 43.0375 34.3019C42.9475 35.2819 42.9475 36.2319 42.7575 37.1419C42.0475 40.5519 39.1175 42.9919 35.6975 43.0619C35.0975 43.0719 34.6775 43.3219 34.3075 43.7719C31.7275 46.9219 28.6575 49.4719 25.2775 51.6819C23.9475 52.5519 22.4975 51.7019 22.4075 50.4319C22.3775 50.0119 22.5575 49.5719 22.6975 49.1519C23.3075 47.3919 23.9575 45.6519 24.5575 43.8819C24.7875 43.1919 24.6575 43.0619 23.9475 43.0619C18.4775 43.0619 13.0075 43.0619 7.54754 43.0619C3.89754 43.0619 0.927524 40.6319 0.157524 37.0219C0.0475244 36.5219 0.0075 36.0019 0.0075 35.4919C-0.0025 29.1319 -0.0025 22.7719 0.0075 16.4119C0.0175 12.1719 3.23753 8.87187 7.41753 8.81187C7.93753 8.80187 8.4575 8.81187 9.0075 8.81187C9.0475 8.04187 9.0475 7.28188 9.1375 6.54188C9.6175 2.85188 12.7075 0.07189 16.3775 0.05189C20.4375 0.03189 24.4975 0.0418802 28.5675 0.0418802C29.1675 0.0418802 29.4975 0.321869 29.5075 0.811869C29.5075 1.29187 29.1575 1.59187 28.5775 1.59187C24.6475 1.59187 20.7175 1.66188 16.7975 1.57188C13.3375 1.50188 10.4475 4.26189 10.5775 7.89189C10.5875 8.18189 10.5775 8.47189 10.5775 8.80189H11.1575C19.2275 8.80189 27.3075 8.79189 35.3775 8.80189C38.9275 8.80189 41.8075 11.0019 42.7075 14.3919C42.8475 14.9319 42.9475 15.5019 42.9575 16.0619C42.9875 18.8619 42.9675 21.6619 42.9775 24.4719C42.9775 24.9419 42.7975 25.2819 42.3175 25.3719C41.9375 25.4419 41.6475 25.2619 41.5175 24.9019C41.4575 24.7319 41.4575 24.5319 41.4575 24.3419C41.4575 21.7419 41.4575 19.1519 41.4575 16.5519C41.4575 12.9419 38.9075 10.3519 35.3475 10.3519C26.1275 10.3419 16.8975 10.3419 7.67754 10.3519C4.08754 10.3519 1.55754 12.9419 1.54754 16.5819C1.54754 22.8219 1.54754 29.0619 1.54754 35.3019C1.54754 38.9019 4.11752 41.5019 7.65752 41.5019C13.1075 41.5019 18.5575 41.5019 24.0075 41.5019C25.6875 41.5019 26.4775 42.5519 26.0675 44.2019C25.5875 46.1319 24.9275 48.0019 24.0975 49.8119C24.0175 49.9819 24.0475 50.2119 24.0275 50.4119C24.2275 50.3619 24.4475 50.3519 24.6075 50.2519C27.8475 48.1719 30.7675 45.7119 33.2075 42.7019C33.8675 41.8919 34.6875 41.5119 35.7275 41.4919C38.8375 41.4319 41.4075 38.7919 41.4475 35.6319C41.4775 33.1919 41.4475 30.7519 41.4575 28.3119C41.4575 27.7919 41.7575 27.4619 42.2075 27.4619C42.6575 27.4519 42.9575 27.7719 42.9775 28.2919C42.9875 28.4119 42.9775 28.5319 42.9775 28.6519V32.6719C47.3975 33.3819 50.4475 30.4619 50.4775 26.8519C50.5375 20.3919 50.5075 13.9219 50.4875 7.46189C50.4775 4.25189 47.8475 1.61187 44.6775 1.59187C40.6875 1.57187 36.6875 1.58189 32.6975 1.58189C32.5075 1.58189 32.3175 1.59188 32.1475 1.54188C31.7575 1.43188 31.5475 1.15188 31.5875 0.731883C31.6275 0.321883 31.8675 0.0818705 32.2675 0.0318705C32.4175 0.0118705 32.5675 0.0218912 32.7275 0.0218912C36.5675 0.0218912 40.4175 0.0818717 44.2575 0.0018717C48.4875 -0.0881283 51.5275 3.08189 51.9475 6.42189C51.9175 6.48188 51.9675 6.52189 51.9975 6.55189Z" fill="#0243A9" />
                            <path d="M34.8075 30.7018C34.6375 30.7618 34.4475 30.7618 34.2575 30.7618C25.7275 30.7618 17.2075 30.7618 8.67753 30.7618C7.96753 30.7618 7.62752 30.5318 7.60752 30.0218C7.59752 29.5818 7.80752 29.3018 8.23752 29.2318C8.40752 29.2018 8.57747 29.2118 8.74747 29.2118H34.1775C34.3475 29.2118 34.5175 29.2018 34.6875 29.2318C35.0775 29.2818 35.2975 29.5418 35.3275 29.9118C35.3575 30.2918 35.1775 30.5818 34.8075 30.7018Z" fill="#0243A9" />
                            <path d="M35.3175 26.5119C35.2675 26.8819 35.0375 27.1319 34.6575 27.1819C34.5075 27.2019 34.3575 27.1919 34.1975 27.1919H21.4575C17.1575 27.1919 12.8675 27.1919 8.56748 27.1919C7.97748 27.1919 7.67753 26.9918 7.61753 26.5618C7.54753 26.1218 7.80747 25.7419 8.24747 25.6619C8.40747 25.6319 8.58748 25.6419 8.75748 25.6419C17.2375 25.6419 25.7075 25.6419 34.1875 25.6419C34.4075 25.6419 34.6375 25.6419 34.8375 25.7119C35.1875 25.8319 35.3675 26.1319 35.3175 26.5119Z" fill="#0243A9" />
                            <path d="M35.3376 33.5219C35.3476 33.9919 34.9976 34.3019 34.4076 34.3019C30.0976 34.3019 25.7776 34.3019 21.4676 34.3019C17.1676 34.3019 12.8776 34.3019 8.5776 34.3019C8.1276 34.3019 7.75759 34.2118 7.62759 33.7218C7.50759 33.2718 7.77763 32.8519 8.23763 32.7719C8.39763 32.7419 8.57758 32.7518 8.74758 32.7518C17.2276 32.7518 25.6976 32.7518 34.1776 32.7518C34.2576 32.7518 34.3476 32.7518 34.4276 32.7518C34.9776 32.7718 35.3276 33.0719 35.3376 33.5219Z" fill="#0243A9" />
                            <path d="M27.8975 15.8619C27.8575 14.9119 26.9275 14.2019 25.9475 14.1819C24.8675 14.1619 23.7875 14.1619 22.6975 14.1819C21.5675 14.2019 20.7175 15.0619 20.6975 16.2119C20.6775 17.1219 20.6775 18.0318 20.6975 18.9418C20.7175 20.1218 21.5675 20.9718 22.7175 21.0018C23.1875 21.0118 23.6575 21.0018 24.1675 21.0018C24.1675 21.4718 24.1675 21.8919 24.1675 22.3219C24.1575 22.7719 24.3275 23.1218 24.7275 23.3418C25.1175 23.5518 25.4775 23.4519 25.8175 23.2119C26.8675 22.4819 27.6575 21.5119 27.7875 20.2319C27.9675 18.7819 27.9575 17.3219 27.8975 15.8619ZM26.3875 19.5519C26.3475 20.1019 26.0675 20.6219 25.8975 21.1619C25.8375 21.1419 25.7775 21.1218 25.7175 21.0918C25.6775 19.8518 25.2675 19.4519 24.0375 19.4519C23.6175 19.4519 23.1875 19.4519 22.7675 19.4519C22.4175 19.4419 22.2375 19.2618 22.2275 18.9018C22.2175 18.0218 22.2175 17.1518 22.2275 16.2818C22.2275 15.9318 22.4275 15.7319 22.7675 15.7319C23.7975 15.7219 24.8275 15.7219 25.8575 15.7319C26.2275 15.7319 26.4175 15.9418 26.4175 16.3118C26.4175 17.3918 26.4675 18.4819 26.3875 19.5519Z" fill="#0243A9" />
                            <path d="M19.4675 15.8619C19.4275 14.9319 18.5174 14.2119 17.5674 14.1919C16.4474 14.1719 15.3375 14.1619 14.2175 14.1919C13.1475 14.2119 12.3075 15.0819 12.2775 16.1719C12.2575 17.1119 12.2575 18.0619 12.2775 19.0019C12.3075 20.1219 13.1474 20.9619 14.2574 21.0019C14.7274 21.0119 15.1974 21.0019 15.7574 21.0019C15.7574 21.4719 15.7674 21.9019 15.7574 22.3319C15.7474 22.7619 15.9075 23.1019 16.2775 23.3219C16.6775 23.5519 17.0475 23.4619 17.4175 23.2119C18.4375 22.5019 19.2275 21.5619 19.3675 20.3319C19.5375 18.8519 19.5275 17.3419 19.4675 15.8619ZM17.9875 19.4119C17.9775 20.0519 17.7575 20.6319 17.2775 21.2219C17.2775 20.9919 17.2775 20.8819 17.2775 20.7719C17.2475 19.9919 16.7674 19.4919 16.0074 19.4619C15.4974 19.4419 14.9975 19.4419 14.4875 19.4619C14.0275 19.4719 13.7975 19.2819 13.7975 18.8019C13.8075 17.9919 13.8075 17.1919 13.7975 16.3819C13.7975 15.9319 14.0174 15.7319 14.4474 15.7319C15.4074 15.7419 16.3774 15.7419 17.3374 15.7319C17.7774 15.7319 17.9974 15.9219 17.9974 16.3819C17.9874 17.3819 18.0075 18.4019 17.9875 19.4119Z" fill="#0243A9" />
                            <path d="M28.2176 37.8219C28.0276 37.8719 27.8176 37.8719 27.6176 37.8819C23.5076 37.8819 19.4076 37.8819 15.2976 37.8819C15.1776 37.8819 15.0576 37.8919 14.9476 37.8819C14.4576 37.8419 14.1276 37.4919 14.1476 37.0619C14.1776 36.6419 14.4976 36.3419 14.9776 36.3419C16.0576 36.3419 17.1376 36.3419 18.2276 36.3419C19.3076 36.3419 20.3876 36.3419 21.4776 36.3419H27.6676C27.8176 36.3419 27.9776 36.3319 28.1276 36.3519C28.5176 36.4019 28.7376 36.6319 28.7776 37.0219C28.7976 37.4219 28.6176 37.7119 28.2176 37.8219Z" fill="#0243A9" />
                          </svg>
                          <div class="offer-card-desc">
                            <span>{jobsQuote}
                            </span>
                            Quotes
                          </div>
                        </div>

                        <div class="offer-card card-dull-blue">
                          <svg width="52" height="53" viewBox="0 0 52 53" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M51.9975 6.55189V27.9019C51.9375 28.0719 51.8475 28.2319 51.8175 28.4019C51.0475 31.8419 48.1075 34.2619 44.6175 34.3019C44.0775 34.3119 43.5475 34.3019 43.0375 34.3019C42.9475 35.2819 42.9475 36.2319 42.7575 37.1419C42.0475 40.5519 39.1175 42.9919 35.6975 43.0619C35.0975 43.0719 34.6775 43.3219 34.3075 43.7719C31.7275 46.9219 28.6575 49.4719 25.2775 51.6819C23.9475 52.5519 22.4975 51.7019 22.4075 50.4319C22.3775 50.0119 22.5575 49.5719 22.6975 49.1519C23.3075 47.3919 23.9575 45.6519 24.5575 43.8819C24.7875 43.1919 24.6575 43.0619 23.9475 43.0619C18.4775 43.0619 13.0075 43.0619 7.54754 43.0619C3.89754 43.0619 0.927524 40.6319 0.157524 37.0219C0.0475244 36.5219 0.0075 36.0019 0.0075 35.4919C-0.0025 29.1319 -0.0025 22.7719 0.0075 16.4119C0.0175 12.1719 3.23753 8.87187 7.41753 8.81187C7.93753 8.80187 8.4575 8.81187 9.0075 8.81187C9.0475 8.04187 9.0475 7.28188 9.1375 6.54188C9.6175 2.85188 12.7075 0.07189 16.3775 0.05189C20.4375 0.03189 24.4975 0.0418802 28.5675 0.0418802C29.1675 0.0418802 29.4975 0.321869 29.5075 0.811869C29.5075 1.29187 29.1575 1.59187 28.5775 1.59187C24.6475 1.59187 20.7175 1.66188 16.7975 1.57188C13.3375 1.50188 10.4475 4.26189 10.5775 7.89189C10.5875 8.18189 10.5775 8.47189 10.5775 8.80189H11.1575C19.2275 8.80189 27.3075 8.79189 35.3775 8.80189C38.9275 8.80189 41.8075 11.0019 42.7075 14.3919C42.8475 14.9319 42.9475 15.5019 42.9575 16.0619C42.9875 18.8619 42.9675 21.6619 42.9775 24.4719C42.9775 24.9419 42.7975 25.2819 42.3175 25.3719C41.9375 25.4419 41.6475 25.2619 41.5175 24.9019C41.4575 24.7319 41.4575 24.5319 41.4575 24.3419C41.4575 21.7419 41.4575 19.1519 41.4575 16.5519C41.4575 12.9419 38.9075 10.3519 35.3475 10.3519C26.1275 10.3419 16.8975 10.3419 7.67754 10.3519C4.08754 10.3519 1.55754 12.9419 1.54754 16.5819C1.54754 22.8219 1.54754 29.0619 1.54754 35.3019C1.54754 38.9019 4.11752 41.5019 7.65752 41.5019C13.1075 41.5019 18.5575 41.5019 24.0075 41.5019C25.6875 41.5019 26.4775 42.5519 26.0675 44.2019C25.5875 46.1319 24.9275 48.0019 24.0975 49.8119C24.0175 49.9819 24.0475 50.2119 24.0275 50.4119C24.2275 50.3619 24.4475 50.3519 24.6075 50.2519C27.8475 48.1719 30.7675 45.7119 33.2075 42.7019C33.8675 41.8919 34.6875 41.5119 35.7275 41.4919C38.8375 41.4319 41.4075 38.7919 41.4475 35.6319C41.4775 33.1919 41.4475 30.7519 41.4575 28.3119C41.4575 27.7919 41.7575 27.4619 42.2075 27.4619C42.6575 27.4519 42.9575 27.7719 42.9775 28.2919C42.9875 28.4119 42.9775 28.5319 42.9775 28.6519V32.6719C47.3975 33.3819 50.4475 30.4619 50.4775 26.8519C50.5375 20.3919 50.5075 13.9219 50.4875 7.46189C50.4775 4.25189 47.8475 1.61187 44.6775 1.59187C40.6875 1.57187 36.6875 1.58189 32.6975 1.58189C32.5075 1.58189 32.3175 1.59188 32.1475 1.54188C31.7575 1.43188 31.5475 1.15188 31.5875 0.731883C31.6275 0.321883 31.8675 0.0818705 32.2675 0.0318705C32.4175 0.0118705 32.5675 0.0218912 32.7275 0.0218912C36.5675 0.0218912 40.4175 0.0818717 44.2575 0.0018717C48.4875 -0.0881283 51.5275 3.08189 51.9475 6.42189C51.9175 6.48188 51.9675 6.52189 51.9975 6.55189Z" fill="#0243A9" />
                            <path d="M34.8075 30.7018C34.6375 30.7618 34.4475 30.7618 34.2575 30.7618C25.7275 30.7618 17.2075 30.7618 8.67753 30.7618C7.96753 30.7618 7.62752 30.5318 7.60752 30.0218C7.59752 29.5818 7.80752 29.3018 8.23752 29.2318C8.40752 29.2018 8.57747 29.2118 8.74747 29.2118H34.1775C34.3475 29.2118 34.5175 29.2018 34.6875 29.2318C35.0775 29.2818 35.2975 29.5418 35.3275 29.9118C35.3575 30.2918 35.1775 30.5818 34.8075 30.7018Z" fill="#0243A9" />
                            <path d="M35.3175 26.5119C35.2675 26.8819 35.0375 27.1319 34.6575 27.1819C34.5075 27.2019 34.3575 27.1919 34.1975 27.1919H21.4575C17.1575 27.1919 12.8675 27.1919 8.56748 27.1919C7.97748 27.1919 7.67753 26.9918 7.61753 26.5618C7.54753 26.1218 7.80747 25.7419 8.24747 25.6619C8.40747 25.6319 8.58748 25.6419 8.75748 25.6419C17.2375 25.6419 25.7075 25.6419 34.1875 25.6419C34.4075 25.6419 34.6375 25.6419 34.8375 25.7119C35.1875 25.8319 35.3675 26.1319 35.3175 26.5119Z" fill="#0243A9" />
                            <path d="M35.3376 33.5219C35.3476 33.9919 34.9976 34.3019 34.4076 34.3019C30.0976 34.3019 25.7776 34.3019 21.4676 34.3019C17.1676 34.3019 12.8776 34.3019 8.5776 34.3019C8.1276 34.3019 7.75759 34.2118 7.62759 33.7218C7.50759 33.2718 7.77763 32.8519 8.23763 32.7719C8.39763 32.7419 8.57758 32.7518 8.74758 32.7518C17.2276 32.7518 25.6976 32.7518 34.1776 32.7518C34.2576 32.7518 34.3476 32.7518 34.4276 32.7518C34.9776 32.7718 35.3276 33.0719 35.3376 33.5219Z" fill="#0243A9" />
                            <path d="M27.8975 15.8619C27.8575 14.9119 26.9275 14.2019 25.9475 14.1819C24.8675 14.1619 23.7875 14.1619 22.6975 14.1819C21.5675 14.2019 20.7175 15.0619 20.6975 16.2119C20.6775 17.1219 20.6775 18.0318 20.6975 18.9418C20.7175 20.1218 21.5675 20.9718 22.7175 21.0018C23.1875 21.0118 23.6575 21.0018 24.1675 21.0018C24.1675 21.4718 24.1675 21.8919 24.1675 22.3219C24.1575 22.7719 24.3275 23.1218 24.7275 23.3418C25.1175 23.5518 25.4775 23.4519 25.8175 23.2119C26.8675 22.4819 27.6575 21.5119 27.7875 20.2319C27.9675 18.7819 27.9575 17.3219 27.8975 15.8619ZM26.3875 19.5519C26.3475 20.1019 26.0675 20.6219 25.8975 21.1619C25.8375 21.1419 25.7775 21.1218 25.7175 21.0918C25.6775 19.8518 25.2675 19.4519 24.0375 19.4519C23.6175 19.4519 23.1875 19.4519 22.7675 19.4519C22.4175 19.4419 22.2375 19.2618 22.2275 18.9018C22.2175 18.0218 22.2175 17.1518 22.2275 16.2818C22.2275 15.9318 22.4275 15.7319 22.7675 15.7319C23.7975 15.7219 24.8275 15.7219 25.8575 15.7319C26.2275 15.7319 26.4175 15.9418 26.4175 16.3118C26.4175 17.3918 26.4675 18.4819 26.3875 19.5519Z" fill="#0243A9" />
                            <path d="M19.4675 15.8619C19.4275 14.9319 18.5174 14.2119 17.5674 14.1919C16.4474 14.1719 15.3375 14.1619 14.2175 14.1919C13.1475 14.2119 12.3075 15.0819 12.2775 16.1719C12.2575 17.1119 12.2575 18.0619 12.2775 19.0019C12.3075 20.1219 13.1474 20.9619 14.2574 21.0019C14.7274 21.0119 15.1974 21.0019 15.7574 21.0019C15.7574 21.4719 15.7674 21.9019 15.7574 22.3319C15.7474 22.7619 15.9075 23.1019 16.2775 23.3219C16.6775 23.5519 17.0475 23.4619 17.4175 23.2119C18.4375 22.5019 19.2275 21.5619 19.3675 20.3319C19.5375 18.8519 19.5275 17.3419 19.4675 15.8619ZM17.9875 19.4119C17.9775 20.0519 17.7575 20.6319 17.2775 21.2219C17.2775 20.9919 17.2775 20.8819 17.2775 20.7719C17.2475 19.9919 16.7674 19.4919 16.0074 19.4619C15.4974 19.4419 14.9975 19.4419 14.4875 19.4619C14.0275 19.4719 13.7975 19.2819 13.7975 18.8019C13.8075 17.9919 13.8075 17.1919 13.7975 16.3819C13.7975 15.9319 14.0174 15.7319 14.4474 15.7319C15.4074 15.7419 16.3774 15.7419 17.3374 15.7319C17.7774 15.7319 17.9974 15.9219 17.9974 16.3819C17.9874 17.3819 18.0075 18.4019 17.9875 19.4119Z" fill="#0243A9" />
                            <path d="M28.2176 37.8219C28.0276 37.8719 27.8176 37.8719 27.6176 37.8819C23.5076 37.8819 19.4076 37.8819 15.2976 37.8819C15.1776 37.8819 15.0576 37.8919 14.9476 37.8819C14.4576 37.8419 14.1276 37.4919 14.1476 37.0619C14.1776 36.6419 14.4976 36.3419 14.9776 36.3419C16.0576 36.3419 17.1376 36.3419 18.2276 36.3419C19.3076 36.3419 20.3876 36.3419 21.4776 36.3419H27.6676C27.8176 36.3419 27.9776 36.3319 28.1276 36.3519C28.5176 36.4019 28.7376 36.6319 28.7776 37.0219C28.7976 37.4219 28.6176 37.7119 28.2176 37.8219Z" fill="#0243A9" />
                          </svg>
                          <div class="offer-card-desc">
                            <span>{conversationsCount}
                            </span>
                            Messages
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                  <div class="Business-Reviews-sec profile-page-sec">
                    <div className='review-card'>
                      <h1 class="heading-anchor">Customer Reviews
                        <div className='review-links'>
                          <a onClick={(e) =>
                          {
                            handleRetrieveReviewOfBusiness(e);
                          }}>
                            View all reviews
                          </a>

                          {jobWithLoggedInUser && (
                            <span> /
                              <a className='write-review-link' onClick={(e) =>

                                handleWriteReviewClick(e)
                              }>
                                Write a Review
                              </a>
                            </span>
                          )}
                        </div>
                      </h1>

                      {reviewOfCustomer.length > 0 ? (
                        <div className="reviews-slider">
                          <div className="testimonial-slider">
                            {reviewOfCustomer.length > 2 ? (

                              <Slider {...settings}>
                                {reviewOfCustomer.map((review) => (
                                  <div className="testimonial-box-data-main" key={`review-${review.reviewId}`}>
                                    <div className="testimonial-box-data">
                                      <figure className="testimonial-user">
                                        <img src={review?.userProfileImage || EmptyProfileImage} alt="User  Profile" />
                                      </figure>
                                      <div className="testimonial-stars">
                                        <StarRating ratings={review?.overallRating} />
                                      </div>
                                      <div className="testimonial-text">
                                        <h5>{review.name}</h5>
                                        <p>
                                          {review.description && review.description !== '' ? (
                                            expandedItems[review.reviewId] ? (
                                              <>
                                                {review.description}
                                                <a
                                                  onClick={() => handleToggleBusinessReview(review.reviewId)}
                                                  style={{ cursor: 'pointer', color: '#0243A9' }}
                                                >
                                                  Read less
                                                </a>
                                              </>
                                            ) : (
                                              <>
                                                {review.description.length > 120
                                                  ? `${review.description.substring(0, 120)}...`
                                                  : review.description}
                                                {review.description.length > 120 && (
                                                  <a
                                                    onClick={() => handleToggleBusinessReview(review.reviewId)}
                                                    style={{ cursor: 'pointer', color: '#0243A9' }}
                                                  >
                                                    Read more
                                                  </a>
                                                )}
                                              </>
                                            )
                                          ) : null}
                                        </p>
                                      </div>
                                      <div className="testimonial-author">
                                        <h5>{review?.userName}</h5>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </Slider>


                            ) : (

                              <div className='testimonial-no-slider'>
                                {reviewOfCustomer.map((review) => (



                                  <div className="testimonial-box-data-main" key={`review-${review.reviewId}`}>
                                    <div className="testimonial-box-data">
                                      <figure className="testimonial-user">
                                        <img src={review?.userProfileImage || EmptyProfileImage} alt="User  Profile" />
                                      </figure>
                                      <div className="testimonial-stars">
                                        <StarRating ratings={review?.overallRating} />
                                      </div>
                                      <div className="testimonial-text">
                                        <h5>{review.name}</h5>
                                        <p>
                                          {review.description && review.description !== '' ? (
                                            expandedItems[review.reviewId] ? (
                                              <>
                                                {review.description}
                                                <a
                                                  onClick={() => handleToggleBusinessReview(review.reviewId)}
                                                  style={{ cursor: 'pointer', color: '#0243A9' }}
                                                >
                                                  Read less
                                                </a>
                                              </>
                                            ) : (
                                              <>
                                                {review.description.length > 120
                                                  ? `${review.description.substring(0, 120)}...`
                                                  : review.description}
                                                {review.description.length > 120 && (
                                                  <a
                                                    onClick={() => handleToggleBusinessReview(review.reviewId)}
                                                    style={{ cursor: 'pointer', color: '#0243A9' }}
                                                  >
                                                    Read more
                                                  </a>
                                                )}
                                              </>
                                            )
                                          ) : null}
                                        </p>
                                      </div>
                                      <div className="testimonial-author">
                                        <h5>{review?.userName}</h5>
                                      </div>
                                    </div>
                                  </div>


                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                      ) : (
                        <p>No customer reviews found.</p>
                      )}
                    </div>
                  </div>

                  <div class="work-portfolio-sec profile-page-sec">
                    <h1 class="heading-anchor">Work Portfolio
                      {(userType == "Business" && loggedBusinessId == businessProfile?.businessId) &&
                        (
                          <div className='review-links'>
                            <a onClick={(e) =>
                            {
                              handleClickAddPortfolio(e)
                            }}>
                              Add Portfolio
                            </a>
                          </div>
                        )
                      }
                    </h1>


                    {(workPortfolios !== null && workPortfolios.length > 0) ? (
                      <div className="reviews-slider">
                        <div className="testimonial-slider">
                          {workPortfolios.length > 2 ? (
                            <Slider {...settings}>
                              {workPortfolios.map((portfolio) => (
                                <div class="testimonial-box-data-main">
                                  <div class="testimonial-box-data">
                                    <div class="edit-icon">
                                      <a class="editCircle" href="#" onClick={(e) => { e.preventDefault(); handleWorkPortfolioEdit(portfolio.portfolioId); }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15" height="15"><g id="_01_align_center" data-name="01 align center"><path d="M22.94,1.06a3.626,3.626,0,0,0-5.124,0L0,18.876V24H5.124L22.94,6.184A3.627,3.627,0,0,0,22.94,1.06ZM4.3,22H2V19.7L15.31,6.4l2.3,2.3ZM21.526,4.77,19.019,7.277l-2.295-2.3L19.23,2.474a1.624,1.624,0,0,1,2.3,2.3Z"></path></g></svg>
                                      </a>

                                      <a class="deleteCircle" href="#" onClick={(e) => { e.preventDefault(); handleWorkPortfolioDelete(portfolio.portfolioId); }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15" height="15"><g id="_01_align_center" data-name="01 align center"><path d="M22,4H17V2a2,2,0,0,0-2-2H9A2,2,0,0,0,7,2V4H2V6H4V21a3,3,0,0,0,3,3H17a3,3,0,0,0,3-3V6h2ZM9,2h6V4H9Zm9,19a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V6H18Z" /><rect x="9" y="10" width="2" height="8" /><rect x="13" y="10" width="2" height="8" /></g></svg>
                                      </a>
                                    </div>

                                    <figure>
                                      <img className='Work-Portfolio-img' src={portfolio?.mediaUrl !== null ? portfolio.mediaUrl[0].url : EmptyBuildStartImage} />
                                    </figure>

                                    <div class="testimonial-text">
                                      <h5>
                                        {portfolio?.title}
                                      </h5>
                                      <p>
                                        {portfolio?.description ? (
                                          <>
                                            {workPortfolioExpandedItems[portfolio.portfolioId] ? (
                                              <>
                                                {portfolio.description}
                                                <a
                                                  onClick={() => handleWorkPortfolioToggle(portfolio.portfolioId)}
                                                  style={{ cursor: 'pointer', color: '#0243A9' }}
                                                >
                                                  Read less
                                                </a>
                                              </>
                                            ) : (
                                              <>
                                                {portfolio.description.length > 120 ? (
                                                  <>
                                                    {`${portfolio.description.substring(0, 120)}...`}
                                                    <a
                                                      onClick={() => handleWorkPortfolioToggle(portfolio.portfolioId)}
                                                      style={{ cursor: 'pointer', color: '#0243A9' }}
                                                    >
                                                      Read more
                                                    </a>
                                                  </>
                                                ) : (
                                                  portfolio.description
                                                )}
                                              </>
                                            )}
                                          </>
                                        ) : null}
                                      </p>
                                      <button type="button" class="more-button" onClick={(e) => { handleclickMorePortfolio(e, portfolio.portfolioId); }}>
                                        More
                                      </button>
                                    </div>

                                  </div>
                                </div>
                              ))}
                            </Slider>
                          ) : (
                            <div className='reviews-flexMode'>
                              {workPortfolios.map((portfolio) => (
                                <div class="testimonial-box-data-main">
                                  <div class="testimonial-box-data">
                                    <div class="edit-icon">
                                      <a class="editCircle" href="#" onClick={(e) => { e.preventDefault(); handleWorkPortfolioEdit(portfolio.portfolioId); }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15" height="15"><g id="_01_align_center" data-name="01 align center"><path d="M22.94,1.06a3.626,3.626,0,0,0-5.124,0L0,18.876V24H5.124L22.94,6.184A3.627,3.627,0,0,0,22.94,1.06ZM4.3,22H2V19.7L15.31,6.4l2.3,2.3ZM21.526,4.77,19.019,7.277l-2.295-2.3L19.23,2.474a1.624,1.624,0,0,1,2.3,2.3Z"></path></g></svg>
                                      </a>

                                      <a class="deleteCircle" href="#" onClick={(e) => { e.preventDefault(); handleWorkPortfolioDelete(portfolio.portfolioId); }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15" height="15"><g id="_01_align_center" data-name="01 align center"><path d="M22,4H17V2a2,2,0,0,0-2-2H9A2,2,0,0,0,7,2V4H2V6H4V21a3,3,0,0,0,3,3H17a3,3,0,0,0,3-3V6h2ZM9,2h6V4H9Zm9,19a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V6H18Z" /><rect x="9" y="10" width="2" height="8" /><rect x="13" y="10" width="2" height="8" /></g></svg>
                                      </a>
                                    </div>
                                    <figure>
                                      <img class="Work-Portfolio-img" src={portfolio?.mediaUrl !== null ? portfolio.mediaUrl[0].url : EmptyBuildStartImage} />
                                    </figure>

                                    <div class="testimonial-text">
                                      <h5>
                                        {portfolio?.title}
                                      </h5>
                                      <p>
                                        {portfolio?.description ? (
                                          <>
                                            {workPortfolioExpandedItems[portfolio.portfolioId] ? (
                                              <>
                                                {portfolio.description}
                                                <a
                                                  onClick={() => handleWorkPortfolioToggle(portfolio.portfolioId)}
                                                  style={{ cursor: 'pointer', color: '#0243A9' }}
                                                >
                                                  Read less
                                                </a>
                                              </>
                                            ) : (
                                              <>
                                                {portfolio.description.length > 120 ? (
                                                  <>
                                                    {`${portfolio.description.substring(0, 120)}...`}
                                                    <a
                                                      onClick={() => handleWorkPortfolioToggle(portfolio.portfolioId)}
                                                      style={{ cursor: 'pointer', color: '#0243A9' }}
                                                    >
                                                      Read more
                                                    </a>
                                                  </>
                                                ) : (
                                                  portfolio.description
                                                )}
                                              </>
                                            )}
                                          </>
                                        ) : null}
                                      </p>
                                      <button type="button" class="more-button" onClick={(e) => { handleclickMorePortfolio(e, portfolio.portfolioId); }}>
                                        More
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    ) : (
                      <p>No work portfolio found.</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </section>
          {isPopupOpen && (
            <div
              className={`write-review-modal modal modal-backdrop-bg fade ${isPopupOpen ? 'show' : ''}`}
              id="exampleModalToggle"
              aria-hidden={!isPopupOpen}
              aria-labelledby="exampleModalToggleLabel"
              tabIndex="-1"
              style={{ display: isPopupOpen ? 'block' : 'none' }}
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalToggleLabel">
                      {businessProfile?.businessName}
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={handleCloseModalReview} // Close the modal using state
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body">

                    <div className="reviewer-detail">
                      <div className="reviewer-name-image">
                        <figure>
                          <img
                            src={loggedUserProfilePic == "null" ? EmptyProfileImage : loggedUserProfilePic}
                            alt={loggedUserName} />
                        </figure>
                        <h3>{loggedUserName}</h3>
                      </div>
                    </div>

                    <div class="rating-reviewer">
                      <div className="star-rating">
                        {Array.from({ length: 5 }, (_, index) =>
                        {
                          const starValue = index + 1;

                          return (
                            <svg
                              key={starValue}
                              width="54"
                              height="54"
                              viewBox="0 0 24 24"
                              fill={starValue <= (hover || rating) ? "#fd9e2b" : "#E4E4E4"}
                              onMouseEnter={() => setHover(starValue)}
                              onMouseLeave={() => setHover(0)}
                              onClick={() => handleRating(starValue)}
                              style={{ cursor: "pointer", marginRight: "8px" }}
                            >
                              <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                            </svg>
                          );
                        })}
                      </div>
                    </div>

                    <div className='review-rating-options'>
                      <div className='rating-qns'>
                        <label> Quality </label>
                        <div>
                          {Array.from({ length: 5 }, (_, index) =>
                          {
                            const starValue = index + 1;

                            return (
                              <svg
                                key={starValue}
                                width="35"
                                height="35"
                                viewBox="0 0 24 24"
                                fill={starValue <= (ratingQualityHover || ratingQuality) ? "#fd9e2b" : "#E4E4E4"}
                                onMouseEnter={() => setRatingQualityHover(starValue)}
                                onMouseLeave={() => setRatingQualityHover(0)}
                                onClick={() => setRatingQuality(starValue)}
                                style={{ cursor: "pointer", marginRight: "8px" }}
                              >
                                <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                              </svg>
                            );
                          })}</div>
                      </div>

                      <div className='rating-qns'>
                        <label>   Service </label><div>
                          {Array.from({ length: 5 }, (_, index) =>
                          {
                            const starValue = index + 1;

                            return (
                              <svg
                                key={starValue}
                                width="35"
                                height="35"
                                viewBox="0 0 24 24"
                                fill={starValue <= (ratingServiceHover || ratingService) ? "#fd9e2b" : "#E4E4E4"}
                                onMouseEnter={() => setRatingServiceHover(starValue)}
                                onMouseLeave={() => setRatingServiceHover(0)}
                                onClick={() => setRatingService(starValue)}
                                style={{ cursor: "pointer", marginRight: "8px" }}
                              >
                                <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                              </svg>
                            );
                          })}
                        </div>
                      </div>

                      <div className='rating-qns'>
                        <label>       Communication</label>
                        <div>        {Array.from({ length: 5 }, (_, index) =>
                        {
                          const starValue = index + 1;

                          return (
                            <svg
                              key={starValue}
                              width="35"
                              height="35"
                              viewBox="0 0 24 24"
                              fill={starValue <= (ratingCommunicationHover || ratingCommunication) ? "#fd9e2b" : "#E4E4E4"}
                              onMouseEnter={() => setRatingCommunicationHover(starValue)}
                              onMouseLeave={() => setRatingCommunicationHover(0)}
                              onClick={() => setRatingCommunication(starValue)}
                              style={{ cursor: "pointer", marginRight: "8px" }}
                            >
                              <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                            </svg>
                          );
                        })}</div>
                      </div>
                      <div className='rating-qns'>
                        <label>   Promptness</label>
                        <div>    {Array.from({ length: 5 }, (_, index) =>
                        {
                          const starValue = index + 1;

                          return (
                            <svg
                              key={starValue}
                              width="35"
                              height="35"
                              viewBox="0 0 24 24"
                              fill={starValue <= (ratingPromptnessHover || ratingPromptness) ? "#fd9e2b" : "#E4E4E4"}
                              onMouseEnter={() => setRatingPromptnessHover(starValue)}
                              onMouseLeave={() => setRatingPromptnessHover(0)}
                              onClick={() => setRatingPromptness(starValue)}
                              style={{ cursor: "pointer", marginRight: "8px" }}
                            >
                              <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                            </svg>
                          );
                        })}</div>
                      </div>

                      <div className='rating-qns'>
                        <label>     Completion </label>
                        <div>   {Array.from({ length: 5 }, (_, index) =>
                        {
                          const starValue = index + 1;

                          return (
                            <svg
                              key={starValue}
                              width="35"
                              height="35"
                              viewBox="0 0 24 24"
                              fill={starValue <= (ratingCompletionHover || ratingCompletion) ? "#fd9e2b" : "#E4E4E4"}
                              onMouseEnter={() => setRatingCompletionHover(starValue)}
                              onMouseLeave={() => setRatingCompletionHover(0)}
                              onClick={() => setRatingCompletion(starValue)}
                              style={{ cursor: "pointer", marginRight: "8px" }}
                            >
                              <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                            </svg>
                          );
                        })}</div>
                      </div>

                    </div>

                    <div class="add-review-box">
                      <textarea placeholder='Write your Review Here' className='form-control' value={reviewDescription} onChange={(e) => setReviewDescription(e.target.value)}></textarea>
                    </div>

                    <div class="custom-upload-file">
                      <div class="drag-drop-button">
                        <input
                          type="file"
                          ref={fileInputRef}
                          multiple
                          accept="image/*,application/pdf"
                          className="hidden"
                          onChange={handleFileChange}
                          id="file-upload"
                        />

                        <span >
                          <label for="file-upload">
                            <des title={files.length > 0 ? files.map(file => file.name).join(', ') : ''}>
                              {files.length > 1
                                ? `${files.length} files selected`
                                : files.length === 1
                                  ? files[0].name
                                  : 'Click here to attach photos'}
                            </des>
                          </label>
                        </span>
                      </div>
                    </div>

                    <div class="review-attachment">
                      {filePreviews.map((file, index) => (
                        <div key={index} className="uploaded-file-box d-flex align-items-center">
                          <figure>
                            <img src={file} alt={`preview-${index}`} />
                            <svg className='close-icon' xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24" width="16" height="16" onClick={() => handleRemoveFile(index)}>
                              <path d="M18,6h0a1,1,0,0,0-1.414,0L12,10.586,7.414,6A1,1,0,0,0,6,6H6A1,1,0,0,0,6,7.414L10.586,12,6,16.586A1,1,0,0,0,6,18H6a1,1,0,0,0,1.414,0L12,13.414,16.586,18A1,1,0,0,0,18,18h0a1,1,0,0,0,0-1.414L13.414,12,18,7.414A1,1,0,0,0,18,6Z" />
                            </svg>
                          </figure>
                        </div>
                      ))}

                      {uploadedFiles.map((file, index) => (
                        <div key={index} className="uploaded-file-box d-flex align-items-center">
                          <figure>
                            <img src={file.url} />
                            <svg className='close-icon' xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24" width="16" height="16" onClick={() => handleRemoveUploadedFile(file.id)}>
                              <path d="M18,6h0a1,1,0,0,0-1.414,0L12,10.586,7.414,6A1,1,0,0,0,6,6H6A1,1,0,0,0,6,7.414L10.586,12,6,16.586A1,1,0,0,0,6,18H6a1,1,0,0,0,1.414,0L12,13.414,16.586,18A1,1,0,0,0,18,18h0a1,1,0,0,0,0-1.414L13.414,12,18,7.414A1,1,0,0,0,18,6Z" />
                            </svg>
                          </figure>
                        </div>
                      ))}
                    </div>
                    <div class="post-review">
                      <button type="button" class="draft-review-button" onClick={() => handleBusinessReview(false)}>
                        Draft
                      </button>
                      <div className="add-review-buttons">
                        <button type="button" class="cancel-review-button" onClick={() => handleCloseModalReview()}>
                          Cancel
                        </button>
                        <button type="button" class="submit-review-button" onClick={() => handleBusinessReview(true)}>
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {isViewReviewPopup && (
            <div
              className={`view-review-modal modal modal-backdrop-bg fade ${isViewReviewPopup ? 'show' : ''}`}
              id="exampleModalToggle"
              aria-hidden={!isViewReviewPopup}
              aria-labelledby="exampleModalToggleLabel"
              tabIndex="-1"
              style={{ display: isViewReviewPopup ? 'block' : 'none' }} // Ensure the modal is displayed
            >
              <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content">

                  <div className="modal-body">
                    <h2 class="heading-anchor">
                      {businessProfile?.businessName}
                      <button type="button" class="btn-close" aria-label="Close" onClick={(e) => setIsViewReviewPopup(false)}></button>
                    </h2>
                    <p className='business-address'>
                      <p>
                        {[
                          businessProfile?.streetName,
                          businessProfile?.suburb,
                          businessProfile?.myState,
                          businessProfile?.postCode,
                        ]
                          .filter(Boolean)
                          .join(', ')}
                      </p>
                    </p>
                    {overallRating > 0 &&
                      (
                        <div className="view-rating">
                          <span class="average-rating">{overallRating}</span>
                          <div class="rating-stars">
                            <StarRating ratings={overallRating} />
                          </div>
                          <span className='rating-count'>{ratingCount} reviews</span>
                        </div>
                      )}
                    {viewReviewForBusiness.length > 0 && (
                      <div class="sort-review-list">
                        <label>Sort by</label>
                        <div class="sort-options">
                          <span className={activeReviewSort === "latest" ? "active" : ""} onClick={() => handleClickReviewSort("latest")}>
                            Latest
                          </span>
                          <span className={activeReviewSort === "highest" ? "active" : ""} onClick={() => handleClickReviewSort("highest")}>
                            Highest
                          </span>
                          <span className={activeReviewSort === "lowest" ? "active" : ""} onClick={() => handleClickReviewSort("lowest")}>
                            Lowest
                          </span>
                        </div>
                      </div>
                    )}


                    {viewReviewForBusiness.length > 0 ? (
                      viewReviewForBusiness.map((review) => (
                        <div class="view-reviews-list">
                          {loading ? <Loader /> : null}
                          <div className="" key={`review-${review.reviewId}`}>
                            <div class="view-review-box">
                              <figure>
                                <img src={review.userProfileImage != null ? review.userProfileImage : EmptyProfileImage} />
                              </figure>
                              <div class="review-text-name">
                                <h4>{review.userName}</h4>
                                <div class="rating-time">
                                  <div class="rating-stars">
                                    <StarRating ratings={review.overallRating} />
                                  </div>
                                  <RecentDate date={review.dateModified} />
                                </div>
                                <div class="review-text">
                                  <p>
                                    {review.description}
                                  </p>
                                </div>

                                <div class="review-attachment">
                                  {review.mediaUrl.length > 0 ?
                                    review.mediaUrl.map((media, index) => (
                                      <figure>
                                        <img src={media.url} alt={media.id} />
                                      </figure>
                                    )) : null}
                                </div>


                              </div>
                            </div>
                          </div>
                        </div>
                      ))) : (<div className="no-reviews-message">
                        <p>No reviews available. <strong>Be the first to leave a review!</strong></p>
                      </div>)}
                  </div>
                </div>
              </div>
            </div>
          )}

          {isAddPortfolioPopup && (
            <div
              className={`modal modal-backdrop-bg fade common-modal AddPortfolioModal ${isAddPortfolioPopup ? 'show' : ''}`}
              id="exampleModalToggle"
              aria-hidden={!isAddPortfolioPopup}
              aria-labelledby="exampleModalToggleLabel"
              tabIndex="-1"
              style={{ display: isAddPortfolioPopup ? 'block' : 'none' }} // Ensure the modal is displayed
            >
              <div className="modal-dialog modal-dialog-centered modal-md">
                <div className="modal-content">

                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalToggleLabel">
                      {editPortfolioStatus ? 'Edit Work Portfolio' : 'Add Work Portfolio'}</h5>
                    <button type="button" class="btn-close" aria-label="Close" onClick={(e) => handleClearAddWorkPortfolioPopup(e)}></button>
                  </div>

                  <div className="modal-body">
                    <form className='common-form'>
                      <div class="form-main">
                        <div class="form-row">
                          <div class="form-group">

                            <div class="form-control-wrapper">
                              <input type="text" class="form-control"
                                value={workPortfolioTitle}
                                onChange={(e) => setWorkPortfolioTitle(e.target.value)}
                                placeholder='Title' />
                            </div>
                            {!workPortfolioTitle && (portfolioFormErrors.portfolioTitle && <span className="error">{portfolioFormErrors.portfolioTitle}</span>)}
                          </div>

                        </div>

                        <div class="form-row">
                          <div class="form-group">

                            <div class="form-control-wrapper">
                              <input
                                class="form-control"
                                type="text"
                                value={searchPostcodeValue}
                                onChange={handleSearchPostcodeChange}
                                placeholder="Postcode"
                              />
                            </div>
                            {!searchPostcodeValue && (portfolioFormErrors.portfolioPostcode && <span className="error">{portfolioFormErrors.portfolioPostcode}</span>)}
                          </div>
                          <div class="form-group">

                            <div className="form-control-wrapper">
                              <select className="form-control" onChange={(e) => setWorkPortfolioSuburb(e.target.value)} value={workPortfolioSuburb}>
                                <option >Select a suburb </option>
                                {results.length > 0 &&
                                  (results.map((item) => (
                                    <option key={item.locality} value={item.locality}>
                                      {item.locality}
                                    </option>
                                  )))}
                              </select>
                            </div>
                            {!workPortfolioSuburb && (portfolioFormErrors.portfolioSuburb && <span className="error">{portfolioFormErrors.portfolioSuburb}</span>)}
                          </div>

                        </div>


                        <div class="form-row">
                          <div class="form-group">

                            <div class="form-control-wrapper">
                              <textarea
                                class="form-control"
                                value={workPortfolioDescription}
                                onChange={(e) => setWorkPortfolioDescription(e.target.value)}
                                placeholder='Description'></textarea>
                            </div>
                            {!workPortfolioDescription && (portfolioFormErrors.portfolioDescription && <span className="error">{portfolioFormErrors.portfolioDescription}</span>)}
                          </div>

                        </div>
                        <div class="custom-upload-file">
                          <div class="drag-drop-button">
                            <input
                              type="file"
                              ref={fileInputRef}
                              multiple
                              accept="image/*,application/pdf"
                              className="hidden"
                              onChange={handleWorkPortfolioFileChange}
                              id="file-upload"
                            />

                            <span >
                              <label for="file-upload">
                                <des title={workPortfolioFiles.length > 0 ? workPortfolioFiles.map(file => file.name).join(', ') : ''}>
                                  {workPortfolioFiles.length > 1
                                    ? `${workPortfolioFiles.length} files selected`
                                    : workPortfolioFiles.length === 1
                                      ? workPortfolioFiles[0].name
                                      : 'Click here to Upload'}
                                </des>
                              </label>
                            </span>
                          </div>
                        </div>

                        <div class="review-attachment">
                          {workPortfolioFilePreviews.map((file, index) => (
                            <div key={index} className="uploaded-file-box d-flex align-items-center">
                              <figure>
                                <img src={file} alt={`preview-${index}`} />
                                <svg className='close-icon' xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24" width="16" height="16" onClick={() => handleWorkPortfolioRemoveFile(index)}>
                                  <path d="M18,6h0a1,1,0,0,0-1.414,0L12,10.586,7.414,6A1,1,0,0,0,6,6H6A1,1,0,0,0,6,7.414L10.586,12,6,16.586A1,1,0,0,0,6,18H6a1,1,0,0,0,1.414,0L12,13.414,16.586,18A1,1,0,0,0,18,18h0a1,1,0,0,0,0-1.414L13.414,12,18,7.414A1,1,0,0,0,18,6Z" />
                                </svg>
                              </figure>
                            </div>
                          ))}

                          {workPortfolioUploadedFiles !== null && workPortfolioUploadedFiles.map((file, index) => (
                            <div key={index} className="uploaded-file-box d-flex align-items-center">
                              <figure>
                                <img src={file.url} />
                                <svg className='close-icon' xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24" width="16" height="16" onClick={() => handleWorkPortfolioRemoveUploadedFile(file.id)}>
                                  <path d="M18,6h0a1,1,0,0,0-1.414,0L12,10.586,7.414,6A1,1,0,0,0,6,6H6A1,1,0,0,0,6,7.414L10.586,12,6,16.586A1,1,0,0,0,6,18H6a1,1,0,0,0,1.414,0L12,13.414,16.586,18A1,1,0,0,0,18,18h0a1,1,0,0,0,0-1.414L13.414,12,18,7.414A1,1,0,0,0,18,6Z" />
                                </svg>
                              </figure>
                            </div>
                          ))}
                        </div>
                      </div>
                    </form>
                    <div class="post-review">
                      <div></div>
                      <div class="add-review-buttons">
                        <button type="button" onClick={(e) => handleClearAddWorkPortfolioPopup(e)} class="cancel-review-button">Cancel</button>
                        <button type="button" onClick={(e) => (editPortfolioStatus ? handleClickEditWorkPortfolio(e) : handleClickWorkPortfolioSubmit(e))} class="submit-review-button">Submit</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {isViewPortfolioPopup && (
            <div
              className={`common-modal view-portfolio-modal modal modal-backdrop-bg fade ${isViewPortfolioPopup ? 'show' : ''}`}
              id="exampleModalToggle"
              aria-hidden={!isViewPortfolioPopup}
              aria-labelledby="exampleModalToggleLabel"
              tabIndex="-1"
              style={{ display: isViewPortfolioPopup ? 'block' : 'none' }} // Ensure the modal is displayed
            >
              <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content">
                  <div className="modal-body">
                    <div className='portfolio-name-location'>
                      <h2 class="heading-anchor">
                        {workPortfolioTitle}
                        <button type="button" class="btn-close" aria-label="Close" onClick={(e) => handleCloseWorkPortfolioMore(e)}></button>
                      </h2>
                      <p className='business-address'>
                        <svg xmlns="http://www.w3.org/2000/svg" id="Isolation_Mode" data-name="Isolation Mode" viewBox="0 0 24 24" width="20" height="20"><path d="M12,.021A10.077,10.077,0,0,0,1.935,10.087c0,5.274,8.166,12.329,9.1,13.117l.967.817.967-.817c.932-.788,9.1-7.843,9.1-13.117A10.077,10.077,0,0,0,12,.021Zm0,20.043c-3.065-2.792-7.067-7.328-7.067-9.977a7.067,7.067,0,1,1,14.134,0C19.067,12.731,15.064,17.269,12,20.064Z" /><circle cx="12" cy="10.002" r="2.997" /></svg>
                        {workPortfolioSuburb} {searchPostcodeValue}
                      </p>
                    </div>
                    <div class="business-description">
                      <p>
                        {workPortfolioDescription}
                      </p>
                    </div>
                    {(workPortfolioUploadedFiles !== null && workPortfolioUploadedFiles.length > 1) ? (
                      <div class="business-attachment">
                        <Slider {...workPortfolio_Settings}>
                          {workPortfolioUploadedFiles !== null &&
                            workPortfolioUploadedFiles.map((file, index) => (
                              <div key={index} >
                                <img src={file.url} alt={`file_${index}`} />
                              </div>
                            ))}
                        </Slider>
                      </div>
                    ) : (
                      <div class="business-attachment">
                        {workPortfolioUploadedFiles !== null &&
                          workPortfolioUploadedFiles.map((file, index) => (
                            <div key={index} >
                              <img class="mw-100" src={file.url} alt={`file_${index}`} />
                            </div>
                          ))}
                      </div>
                    )}

                  </div>
                </div>
              </div>
            </div>
          )}
          <Footer />
        </>
      )
      }: {
        <>
          {loading ? <Loader /> : null}
        </>}
    </>
  );
};

export default BusinessProfile;
